var _style, _rect, _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 307.9 239.5",
    style: {
      enableBackground: "new 0 0 307.9 239.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.Graphic_x0020_Style_x0020_2{fill:#22F5EC;}\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#FFFFFF;}\r\n\t.st2{display:inline;}\r\n\t.st3{clip-path:url(#XMLID_00000047050369953019692820000017953862141168838022_);}\r\n\t.st4{fill:url(#XMLID_00000001658810766209500440000004748733561911240621_);}\r\n\t.st5{fill:url(#XMLID_00000038392840837243942560000015284129146573108387_);}\r\n\t.st6{fill:url(#XMLID_00000101824761197957127950000017602822918369401747_);}\r\n\t.st7{fill:url(#XMLID_00000111162413959781131370000014582181509435369140_);}\r\n\t.st8{fill:url(#XMLID_00000024706639651180511630000009677113685410156982_);}\r\n\t.st9{fill:url(#XMLID_00000167386633029252444260000013332836353813830806_);}\r\n\t.st10{fill:url(#XMLID_00000169515556980722493310000003787706348033469116_);}\r\n\t.st11{fill:url(#XMLID_00000116228496670307659890000005233871585481834918_);}\r\n\t.st12{fill:url(#XMLID_00000071535540080175182160000008097082872111290302_);}\r\n\t.st13{fill:url(#XMLID_00000143617005236137646500000012313187608636254106_);}\r\n\t.st14{fill:url(#XMLID_00000165223686389621667630000017162302509830492858_);}\r\n\t.st15{fill:url(#XMLID_00000029045804341853986110000009383581416053042364_);}\r\n\t.st16{fill:url(#XMLID_00000088101772652837720580000014979082029907655833_);}\r\n\t.st17{fill:url(#XMLID_00000010270476104740333880000009161892477304098951_);}\r\n\t.st18{fill:url(#XMLID_00000065034461505009442900000000016926201639882121_);}\r\n\t.st19{fill:url(#XMLID_00000142893673584325479980000004698758317481308803_);}\r\n\t.st20{fill:url(#XMLID_00000085228076354648714900000005197235568230460802_);}\r\n\t.st21{fill:url(#XMLID_00000009588165256424745630000000291906234476096907_);}\r\n\t.st22{fill:url(#XMLID_00000182508354531952149700000003924775049660604816_);}\r\n\t.st23{fill:url(#XMLID_00000080166573114349518180000006685454911383126163_);}\r\n\t.st24{fill:url(#XMLID_00000114037775275801263520000011592662551466354087_);}\r\n\t.st25{fill:url(#XMLID_00000065767561389303003620000009045180875168585147_);}\r\n\t.st26{fill:url(#XMLID_00000147191404552008946610000000023655964266655645_);}\r\n\t.st27{fill:url(#XMLID_00000031905263051970629770000004944365032337774510_);}\r\n\t.st28{fill:url(#XMLID_00000152233419164882972290000001551785667362599561_);}\r\n\t.st29{fill:url(#XMLID_00000125570613623948625020000003113307229335972233_);}\r\n\t.st30{fill:url(#XMLID_00000073715697477367645200000001846085846911889590_);}\r\n\t.st31{fill:url(#XMLID_00000161610397812626951040000008600835908175895440_);}\r\n\t.st32{fill:url(#XMLID_00000072989615168538321380000012576359554378344067_);}\r\n\t.st33{fill:url(#XMLID_00000147192173279116011340000009660078395704981918_);}\r\n\t.st34{fill:url(#XMLID_00000076576097675597027730000013430822831177174160_);}\r\n\t.st35{fill:url(#XMLID_00000122699106327674135770000004067434656676347325_);}\r\n\t.st36{fill:url(#XMLID_00000133520748955384402110000001069712211572383635_);}\r\n\t.st37{fill:url(#XMLID_00000057843315625053671420000003676478772693573276_);}\r\n\t.st38{fill:url(#XMLID_00000109023137509117408510000017865579299570453417_);}\r\n\t.st39{fill:url(#XMLID_00000136383261591375483440000005084523847150361495_);}\r\n\t.st40{fill:url(#XMLID_00000139271895265742654280000014496922491525527446_);}\r\n\t.st41{fill:url(#XMLID_00000029036129926734402780000017914063581055775888_);}\r\n\t.st42{fill:url(#XMLID_00000085929404014264352880000005260670931719292061_);}\r\n\t.st43{fill:url(#XMLID_00000051347594312954390440000016908691372185352610_);}\r\n\t.st44{fill:url(#XMLID_00000153705234140246571060000014987875792594397851_);}\r\n\t.st45{fill:url(#XMLID_00000093867672863359407610000005682362369145635746_);}\r\n\t.st46{fill:url(#XMLID_00000121961934181056677540000007914859364388182154_);}\r\n\t.st47{fill:url(#XMLID_00000070090002555680656190000013849139700577256382_);}\r\n\t.st48{fill:url(#XMLID_00000060032449832914439950000012006263664507387014_);}\r\n\t.st49{fill:#E60733;}\r\n\t.st50{fill:#1D262D;}\r\n\t.st51{fill:#22F5EC;}\r\n\t.st52{opacity:5.000000e-02;}\r\n\t.st53{fill:#59FFD1;}\r\n\t.st54{opacity:0.1556;}\r\n\t.st55{opacity:0.2611;}\r\n\t.st56{opacity:0.3667;}\r\n\t.st57{opacity:0.4722;}\r\n\t.st58{opacity:0.5778;}\r\n\t.st59{opacity:0.6833;}\r\n\t.st60{opacity:0.7889;}\r\n\t.st61{opacity:0.8944;}\r\n\t.st62{fill:#CB193B;}\r\n\t.st63{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND",
    className: "st0"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1_",
    x: -97.5,
    y: -130.1,
    className: "st1",
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_418_",
    className: "st2"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_417_",
    x: -97.5,
    y: -130.1,
    width: 500,
    height: 500
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000079487022746470568770000015876425142174245252_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_417_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_137_",
    style: {
      clipPath: "url(#XMLID_00000079487022746470568770000015876425142174245252_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_134_"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000157286036010604517960000010869468875910922407_",
    cx: 151.0644,
    cy: 137.6176,
    r: 487.1627,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_133_",
    x: -99.5,
    y: -128,
    style: {
      fill: "url(#XMLID_00000157286036010604517960000010869468875910922407_)"
    },
    width: 509,
    height: 3
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000021821056455718529550000016528117417383518618_",
    cx: 151.0644,
    cy: 137.6116,
    r: 487.1603,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_135_",
    x: -99.5,
    y: -111.3,
    style: {
      fill: "url(#XMLID_00000021821056455718529550000016528117417383518618_)"
    },
    width: 509,
    height: 1.5
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000057859858128176787670000010385162456333450920_",
    cx: 151.0644,
    cy: 137.6184,
    r: 487.1629,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_136_",
    x: -99.5,
    y: -134.7,
    style: {
      fill: "url(#XMLID_00000057859858128176787670000010385162456333450920_)"
    },
    width: 509,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_138_"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000066497452366601098820000007307133345464897204_",
    cx: 151.0644,
    cy: 137.6198,
    r: 487.1658,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_272_",
    x: -99.5,
    y: -93,
    style: {
      fill: "url(#XMLID_00000066497452366601098820000007307133345464897204_)"
    },
    width: 509,
    height: 3
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000063613000812697299360000018421576209104047767_",
    cx: 151.0644,
    cy: 137.6126,
    r: 487.1604,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_140_",
    x: -99.5,
    y: -76.3,
    style: {
      fill: "url(#XMLID_00000063613000812697299360000018421576209104047767_)"
    },
    width: 509,
    height: 1.5
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000061464890445975507290000005557876431094475436_",
    cx: 151.0644,
    cy: 137.6079,
    r: 487.159,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_139_",
    x: -99.5,
    y: -99.8,
    style: {
      fill: "url(#XMLID_00000061464890445975507290000005557876431094475436_)"
    },
    width: 509,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_318_"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000005239280340977262300000001661650931593512121_",
    cx: 151.0644,
    cy: 137.6131,
    r: 487.1634,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_354_",
    x: -99.5,
    y: -58,
    style: {
      fill: "url(#XMLID_00000005239280340977262300000001661650931593512121_)"
    },
    width: 509,
    height: 3
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000119822437327852373690000001664392014487273880_",
    cx: 151.0644,
    cy: 137.6133,
    r: 487.1637,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_353_",
    x: -99.5,
    y: -41.4,
    style: {
      fill: "url(#XMLID_00000119822437327852373690000001664392014487273880_)"
    },
    width: 509,
    height: 1.5
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000008840121537092542680000018219128335024596358_",
    cx: 151.0644,
    cy: 137.6094,
    r: 487.1607,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_347_",
    x: -99.5,
    y: -64.8,
    style: {
      fill: "url(#XMLID_00000008840121537092542680000018219128335024596358_)"
    },
    width: 509,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_355_"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000143585596723483605430000009405954819875712440_",
    cx: 151.0644,
    cy: 137.6192,
    r: 487.1668,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_359_",
    x: -99.5,
    y: -23.1,
    style: {
      fill: "url(#XMLID_00000143585596723483605430000009405954819875712440_)"
    },
    width: 509,
    height: 3
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000039092998504548318230000010835294152587808689_",
    cx: 151.0644,
    cy: 137.6142,
    r: 487.1645,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_357_",
    x: -99.5,
    y: -6.4,
    style: {
      fill: "url(#XMLID_00000039092998504548318230000010835294152587808689_)"
    },
    width: 509,
    height: 1.5
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000101804348001840984070000006248178074668829615_",
    cx: 151.0644,
    cy: 137.6107,
    r: 487.1619,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_356_",
    x: -99.5,
    y: -29.9,
    style: {
      fill: "url(#XMLID_00000101804348001840984070000006248178074668829615_)"
    },
    width: 509,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_360_"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000107582783386995671480000006426245759267393443_",
    cx: 151.0644,
    cy: 137.6146,
    r: 487.165,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_376_",
    x: -99.5,
    y: 11.9,
    style: {
      fill: "url(#XMLID_00000107582783386995671480000006426245759267393443_)"
    },
    width: 509,
    height: 3
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000168076146751206030710000015429491646861311679_",
    cx: 151.0644,
    cy: 137.6223,
    r: 487.1679,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_375_",
    x: -99.5,
    y: 28.6,
    style: {
      fill: "url(#XMLID_00000168076146751206030710000015429491646861311679_)"
    },
    width: 509,
    height: 1.5
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000098198876242149011030000005762369975546185363_",
    cx: 151.0644,
    cy: 137.6122,
    r: 487.1641,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_374_",
    x: -99.5,
    y: 5.1,
    style: {
      fill: "url(#XMLID_00000098198876242149011030000005762369975546185363_)"
    },
    width: 509,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_377_"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000132064427824989611810000018099680084789238145_",
    cx: 151.0644,
    cy: 137.6183,
    r: 487.1675,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_380_",
    x: -99.5,
    y: 46.9,
    style: {
      fill: "url(#XMLID_00000132064427824989611810000018099680084789238145_)"
    },
    width: 509,
    height: 3
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000147926852143234316850000007915884898015795126_",
    cx: 151.0644,
    cy: 137.6158,
    r: 487.1664,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_379_",
    x: -99.5,
    y: 63.5,
    style: {
      fill: "url(#XMLID_00000147926852143234316850000007915884898015795126_)"
    },
    width: 509,
    height: 1.5
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000047744718704788408140000012589991294592178312_",
    cx: 151.0644,
    cy: 137.6136,
    r: 487.1641,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_378_",
    x: -99.5,
    y: 40.1,
    style: {
      fill: "url(#XMLID_00000047744718704788408140000012589991294592178312_)"
    },
    width: 509,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_381_"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000176003028677751709180000004365778260760839075_",
    cx: 151.0644,
    cy: 137.6163,
    r: 487.166,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_384_",
    x: -99.5,
    y: 81.8,
    style: {
      fill: "url(#XMLID_00000176003028677751709180000004365778260760839075_)"
    },
    width: 509,
    height: 3
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000061443861761866812600000010670884163319491206_",
    cx: 151.0644,
    cy: 137.6192,
    r: 487.167,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_383_",
    x: -99.5,
    y: 98.5,
    style: {
      fill: "url(#XMLID_00000061443861761866812600000010670884163319491206_)"
    },
    width: 509,
    height: 1.5
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000032622317479785562070000008938458791494147003_",
    cx: 151.0644,
    cy: 137.615,
    r: 487.167,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_382_",
    x: -99.5,
    y: 75,
    style: {
      fill: "url(#XMLID_00000032622317479785562070000008938458791494147003_)"
    },
    width: 509,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_385_"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000032633688991522111980000011303682498820726696_",
    cx: 151.0644,
    cy: 137.6177,
    r: 487.168,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_388_",
    x: -99.5,
    y: 116.8,
    style: {
      fill: "url(#XMLID_00000032633688991522111980000011303682498820726696_)"
    },
    width: 509,
    height: 3
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000057119302907310437030000005363712981577853885_",
    cx: 151.0644,
    cy: 137.6174,
    r: 487.1671,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_387_",
    x: -99.5,
    y: 133.5,
    style: {
      fill: "url(#XMLID_00000057119302907310437030000005363712981577853885_)"
    },
    width: 509,
    height: 1.5
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000103943778843486394870000007865743380726098877_",
    cx: 151.0644,
    cy: 137.6163,
    r: 487.1679,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_386_",
    x: -99.5,
    y: 110,
    style: {
      fill: "url(#XMLID_00000103943778843486394870000007865743380726098877_)"
    },
    width: 509,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_389_"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000092441914615966266290000016550564241989555883_",
    cx: 151.0644,
    cy: 137.6174,
    r: 487.1676,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_392_",
    x: -99.5,
    y: 151.8,
    style: {
      fill: "url(#XMLID_00000092441914615966266290000016550564241989555883_)"
    },
    width: 509,
    height: 3
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000113313177333393450860000017697069227971644084_",
    cx: 151.0644,
    cy: 137.6161,
    r: 487.1665,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_391_",
    x: -99.5,
    y: 168.4,
    style: {
      fill: "url(#XMLID_00000113313177333393450860000017697069227971644084_)"
    },
    width: 509,
    height: 1.5
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000101064850881116423910000002866486134952603276_",
    cx: 151.0644,
    cy: 137.6178,
    r: 487.1683,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_390_",
    x: -99.5,
    y: 145,
    style: {
      fill: "url(#XMLID_00000101064850881116423910000002866486134952603276_)"
    },
    width: 509,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_393_"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000085960632972693198750000000137311586390156954_",
    cx: 151.0644,
    cy: 137.6171,
    r: 487.1682,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_396_",
    x: -99.5,
    y: 186.7,
    style: {
      fill: "url(#XMLID_00000085960632972693198750000000137311586390156954_)"
    },
    width: 509,
    height: 3
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000039821876174363117290000014230394878187105421_",
    cx: 151.0644,
    cy: 137.619,
    r: 487.1671,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_395_",
    x: -99.5,
    y: 203.4,
    style: {
      fill: "url(#XMLID_00000039821876174363117290000014230394878187105421_)"
    },
    width: 509,
    height: 1.5
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000109009818235868555940000005754784747450592688_",
    cx: 151.0644,
    cy: 137.6101,
    r: 487.1693,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_394_",
    x: -99.5,
    y: 179.9,
    style: {
      fill: "url(#XMLID_00000109009818235868555940000005754784747450592688_)"
    },
    width: 509,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_397_"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000099625597223348531220000009724846744291558306_",
    cx: 151.0644,
    cy: 137.6167,
    r: 487.167,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_400_",
    x: -99.5,
    y: 221.7,
    style: {
      fill: "url(#XMLID_00000099625597223348531220000009724846744291558306_)"
    },
    width: 509,
    height: 3
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000124139624184614895050000016464904419345798331_",
    cx: 151.0644,
    cy: 137.6131,
    r: 487.1679,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_399_",
    x: -99.5,
    y: 238.3,
    style: {
      fill: "url(#XMLID_00000124139624184614895050000016464904419345798331_)"
    },
    width: 509,
    height: 1.5
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000132807489813746023890000017723721566403687300_",
    cx: 151.0644,
    cy: 137.6207,
    r: 487.1662,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_398_",
    x: -99.5,
    y: 214.9,
    style: {
      fill: "url(#XMLID_00000132807489813746023890000017723721566403687300_)"
    },
    width: 509,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_401_"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000128452062661156516470000007512896518654197418_",
    cx: 151.0644,
    cy: 137.6162,
    r: 487.1676,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_404_",
    x: -99.5,
    y: 256.6,
    style: {
      fill: "url(#XMLID_00000128452062661156516470000007512896518654197418_)"
    },
    width: 509,
    height: 3
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000181053221516381721120000014882014945209478556_",
    cx: 151.0644,
    cy: 137.6207,
    r: 487.1647,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_403_",
    x: -99.5,
    y: 273.3,
    style: {
      fill: "url(#XMLID_00000181053221516381721120000014882014945209478556_)"
    },
    width: 509,
    height: 1.5
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000016774348071703819630000016252528924871050918_",
    cx: 151.0644,
    cy: 137.5974,
    r: 487.1751,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_402_",
    x: -99.5,
    y: 249.9,
    style: {
      fill: "url(#XMLID_00000016774348071703819630000016252528924871050918_)"
    },
    width: 509,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_405_"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000080884898942795481790000009419088606173387668_",
    cx: 151.0644,
    cy: 137.6158,
    r: 487.1668,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_408_",
    x: -99.5,
    y: 291.6,
    style: {
      fill: "url(#XMLID_00000080884898942795481790000009419088606173387668_)"
    },
    width: 509,
    height: 3
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000163769930137642762250000012453930559338840477_",
    cx: 151.0644,
    cy: 137.6215,
    r: 487.1645,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_407_",
    x: -99.5,
    y: 308.3,
    style: {
      fill: "url(#XMLID_00000163769930137642762250000012453930559338840477_)"
    },
    width: 509,
    height: 1.5
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000106132361434406395220000007330674911180462768_",
    cx: 151.0644,
    cy: 137.6234,
    r: 487.163,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_406_",
    x: -99.5,
    y: 284.8,
    style: {
      fill: "url(#XMLID_00000106132361434406395220000007330674911180462768_)"
    },
    width: 509,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_409_"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000126283812242198901240000011374469504452372399_",
    cx: 151.0644,
    cy: 137.6221,
    r: 487.1615,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_412_",
    x: -99.5,
    y: 326.6,
    style: {
      fill: "url(#XMLID_00000126283812242198901240000011374469504452372399_)"
    },
    width: 509,
    height: 3
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000059301386268585360170000002229356851451791495_",
    cx: 151.0644,
    cy: 137.6223,
    r: 487.1618,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_411_",
    x: -99.5,
    y: 343.2,
    style: {
      fill: "url(#XMLID_00000059301386268585360170000002229356851451791495_)"
    },
    width: 509,
    height: 1.5
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000142872422824547300200000004347516872748550272_",
    cx: 151.0644,
    cy: 137.6249,
    r: 487.1617,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_410_",
    x: -99.5,
    y: 319.8,
    style: {
      fill: "url(#XMLID_00000142872422824547300200000004347516872748550272_)"
    },
    width: 509,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_413_"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000068637385681881106690000012134601317566029977_",
    cx: 151.0644,
    cy: 137.6152,
    r: 487.1657,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_416_",
    x: -99.5,
    y: 361.5,
    style: {
      fill: "url(#XMLID_00000068637385681881106690000012134601317566029977_)"
    },
    width: 509,
    height: 3
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000152263412227775554150000003790860636855909807_",
    cx: 151.0644,
    cy: 137.6231,
    r: 487.1591,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_415_",
    x: -99.5,
    y: 378.2,
    style: {
      fill: "url(#XMLID_00000152263412227775554150000003790860636855909807_)"
    },
    width: 509,
    height: 1.5
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000012446593350452118130000013317766104061534604_",
    cx: 151.0644,
    cy: 137.6263,
    r: 487.1577,
    gradientTransform: "matrix(0.7698 0 0 1 35.5548 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    style: {
      stopColor: "#FAFBFC",
      stopOpacity: 0.1817
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#ECF1F4",
      stopOpacity: 0.3967
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0.6285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8706,
    style: {
      stopColor: "#B3C6D3",
      stopOpacity: 0.8706
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB7C7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_414_",
    x: -99.5,
    y: 354.8,
    style: {
      fill: "url(#XMLID_00000012446593350452118130000013317766104061534604_)"
    },
    width: 509,
    height: 0.5
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_131_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_43_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M67.5,37.7H45.7v20.2H70V64H38.5V7.9h30.3V14H45.7v17.7h21.8V37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M79.4,8.6c3.7-0.7,8.9-1.2,13.9-1.2c7.7,0,12.7,1.4,16.2,4.6 c2.8,2.5,4.4,6.3,4.4,10.7c0,7.4-4.7,12.3-10.6,14.3v0.2c4.3,1.5,6.9,5.5,8.2,11.3c1.8,7.8,3.2,13.2,4.3,15.4h-7.5 c-0.9-1.6-2.2-6.4-3.7-13.4c-1.7-7.7-4.7-10.7-11.2-10.9h-6.8V64h-7.2V8.6z M86.7,34.2h7.4c7.7,0,12.7-4.2,12.7-10.7 c0-7.2-5.2-10.4-12.9-10.5c-3.5,0-6,0.3-7.2,0.7V34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M124.2,8.6c3.7-0.7,8.9-1.2,13.9-1.2c7.7,0,12.7,1.4,16.2,4.6 c2.8,2.5,4.4,6.3,4.4,10.7c0,7.4-4.7,12.3-10.6,14.3v0.2c4.3,1.5,6.9,5.5,8.2,11.3c1.8,7.8,3.2,13.2,4.3,15.4h-7.5 c-0.9-1.6-2.2-6.4-3.7-13.4c-1.7-7.7-4.7-10.7-11.2-10.9h-6.8V64h-7.2V8.6z M131.4,34.2h7.4c7.7,0,12.7-4.2,12.7-10.7 c0-7.2-5.2-10.4-12.9-10.5c-3.5,0-6,0.3-7.2,0.7V34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M217.2,35.4c0,19.3-11.7,29.6-26.1,29.6c-14.8,0-25.2-11.5-25.2-28.5 C165.9,18.6,177,7,192,7C207.3,7,217.2,18.7,217.2,35.4z M173.6,36.3c0,12,6.5,22.7,17.9,22.7c11.5,0,18-10.6,18-23.3 c0-11.2-5.8-22.8-17.9-22.8C179.6,12.9,173.6,24,173.6,36.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M226.6,8.6c3.7-0.7,8.9-1.2,13.9-1.2c7.7,0,12.7,1.4,16.2,4.6 c2.8,2.5,4.4,6.3,4.4,10.7c0,7.4-4.7,12.3-10.6,14.3v0.2c4.3,1.5,6.9,5.5,8.2,11.3c1.8,7.8,3.2,13.2,4.3,15.4h-7.5 c-0.9-1.6-2.2-6.4-3.7-13.4c-1.7-7.7-4.7-10.7-11.2-10.9h-6.8V64h-7.2V8.6z M233.8,34.2h7.4c7.7,0,12.7-4.2,12.7-10.7 c0-7.2-5.2-10.4-12.9-10.5c-3.5,0-6,0.3-7.2,0.7V34.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M75.5,37.7H53.7v20.2H78V64H46.5V7.9h30.3V14H53.7v17.7h21.8V37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M87.4,8.6c3.7-0.7,8.9-1.2,13.9-1.2c7.7,0,12.7,1.4,16.2,4.6c2.8,2.5,4.4,6.3,4.4,10.7 c0,7.4-4.7,12.3-10.6,14.3v0.2c4.3,1.5,6.9,5.5,8.2,11.3c1.8,7.8,3.2,13.2,4.3,15.4h-7.5c-0.9-1.6-2.2-6.4-3.7-13.4 c-1.7-7.7-4.7-10.7-11.2-10.9h-6.8V64h-7.2V8.6z M94.7,34.2h7.4c7.7,0,12.7-4.2,12.7-10.7c0-7.2-5.2-10.4-12.9-10.5 c-3.5,0-6,0.3-7.2,0.7V34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M132.2,8.6c3.7-0.7,8.9-1.2,13.9-1.2c7.7,0,12.7,1.4,16.2,4.6c2.8,2.5,4.4,6.3,4.4,10.7 c0,7.4-4.7,12.3-10.6,14.3v0.2c4.3,1.5,6.9,5.5,8.2,11.3c1.8,7.8,3.2,13.2,4.3,15.4h-7.5c-0.9-1.6-2.2-6.4-3.7-13.4 c-1.7-7.7-4.7-10.7-11.2-10.9h-6.8V64h-7.2V8.6z M139.4,34.2h7.4c7.7,0,12.7-4.2,12.7-10.7c0-7.2-5.2-10.4-12.9-10.5 c-3.5,0-6,0.3-7.2,0.7V34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M225.2,35.4c0,19.3-11.7,29.6-26.1,29.6c-14.8,0-25.2-11.5-25.2-28.5C173.9,18.6,185,7,200,7 C215.3,7,225.2,18.7,225.2,35.4z M181.6,36.3c0,12,6.5,22.7,17.9,22.7c11.5,0,18-10.6,18-23.3c0-11.2-5.8-22.8-17.9-22.8 C187.6,12.9,181.6,24,181.6,36.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M234.6,8.6c3.7-0.7,8.9-1.2,13.9-1.2c7.7,0,12.7,1.4,16.2,4.6c2.8,2.5,4.4,6.3,4.4,10.7 c0,7.4-4.7,12.3-10.6,14.3v0.2c4.3,1.5,6.9,5.5,8.2,11.3c1.8,7.8,3.2,13.2,4.3,15.4h-7.5c-0.9-1.6-2.2-6.4-3.7-13.4 c-1.7-7.7-4.7-10.7-11.2-10.9h-6.8V64h-7.2V8.6z M241.8,34.2h7.4c7.7,0,12.7-4.2,12.7-10.7c0-7.2-5.2-10.4-12.9-10.5 c-3.5,0-6,0.3-7.2,0.7V34.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M71.5,37.7H49.7v20.2H74V64H42.5V7.9h30.3V14H49.7v17.7h21.8V37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M83.4,8.6c3.7-0.7,8.9-1.2,13.9-1.2c7.7,0,12.7,1.4,16.2,4.6c2.8,2.5,4.4,6.3,4.4,10.7 c0,7.4-4.7,12.3-10.6,14.3v0.2c4.3,1.5,6.9,5.5,8.2,11.3c1.8,7.8,3.2,13.2,4.3,15.4h-7.5c-0.9-1.6-2.2-6.4-3.7-13.4 c-1.7-7.7-4.7-10.7-11.2-10.9h-6.8V64h-7.2V8.6z M90.7,34.2h7.4c7.7,0,12.7-4.2,12.7-10.7c0-7.2-5.2-10.4-12.9-10.5 c-3.5,0-6,0.3-7.2,0.7V34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M128.2,8.6c3.7-0.7,8.9-1.2,13.9-1.2c7.7,0,12.7,1.4,16.2,4.6c2.8,2.5,4.4,6.3,4.4,10.7 c0,7.4-4.7,12.3-10.6,14.3v0.2c4.3,1.5,6.9,5.5,8.2,11.3c1.8,7.8,3.2,13.2,4.3,15.4h-7.5c-0.9-1.6-2.2-6.4-3.7-13.4 c-1.7-7.7-4.7-10.7-11.2-10.9h-6.8V64h-7.2V8.6z M135.4,34.2h7.4c7.7,0,12.7-4.2,12.7-10.7c0-7.2-5.2-10.4-12.9-10.5 c-3.5,0-6,0.3-7.2,0.7V34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M221.2,35.4c0,19.3-11.7,29.6-26.1,29.6c-14.8,0-25.2-11.5-25.2-28.5C169.9,18.6,181,7,196,7 C211.3,7,221.2,18.7,221.2,35.4z M177.6,36.3c0,12,6.5,22.7,17.9,22.7c11.5,0,18-10.6,18-23.3c0-11.2-5.8-22.8-17.9-22.8 C183.6,12.9,177.6,24,177.6,36.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M230.6,8.6c3.7-0.7,8.9-1.2,13.9-1.2c7.7,0,12.7,1.4,16.2,4.6c2.8,2.5,4.4,6.3,4.4,10.7 c0,7.4-4.7,12.3-10.6,14.3v0.2c4.3,1.5,6.9,5.5,8.2,11.3c1.8,7.8,3.2,13.2,4.3,15.4h-7.5c-0.9-1.6-2.2-6.4-3.7-13.4 c-1.7-7.7-4.7-10.7-11.2-10.9h-6.8V64h-7.2V8.6z M237.8,34.2h7.4c7.7,0,12.7-4.2,12.7-10.7c0-7.2-5.2-10.4-12.9-10.5 c-3.5,0-6,0.3-7.2,0.7V34.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M42.6,208.1c1.3-0.2,3.1-0.4,5.3-0.4c2.7,0,4.7,0.6,6,1.8c1.2,1,1.9,2.6,1.9,4.5c0,1.9-0.6,3.5-1.6,4.6 c-1.5,1.6-3.8,2.3-6.5,2.3c-0.8,0-1.6,0-2.2-0.2v8.5h-2.8V208.1z M45.4,218.4c0.6,0.2,1.4,0.2,2.3,0.2c3.3,0,5.4-1.6,5.4-4.6 c0-2.8-2-4.2-5-4.2c-1.2,0-2.1,0.1-2.6,0.2V218.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M60.3,222.4l-2.2,6.7h-2.8l7.3-21.3h3.3l7.3,21.3h-2.9l-2.3-6.7H60.3z M67.3,220.3l-2.1-6.1 c-0.5-1.4-0.8-2.7-1.1-3.9H64c-0.3,1.3-0.7,2.6-1.1,3.9l-2.1,6.2H67.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M92,228.2c-1.2,0.4-3.7,1.2-6.6,1.2c-3.2,0-5.9-0.8-8-2.8c-1.8-1.8-3-4.6-3-7.9c0-6.4,4.4-11,11.6-11 c2.5,0,4.4,0.5,5.3,1l-0.7,2.2c-1.1-0.5-2.6-0.9-4.7-0.9c-5.2,0-8.6,3.2-8.6,8.6c0,5.4,3.3,8.6,8.2,8.6c1.8,0,3-0.3,3.7-0.6 v-6.4h-4.3v-2.2h7V228.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M107.2,219.1h-8.3v7.7h9.2v2.3h-12v-21.3h11.5v2.3h-8.8v6.7h8.3V219.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M118.5,229.2v-21.3h3l6.8,10.8c1.6,2.5,2.8,4.7,3.8,6.9l0.1,0c-0.3-2.8-0.3-5.4-0.3-8.8v-8.9h2.6v21.3 h-2.8l-6.8-10.8c-1.5-2.4-2.9-4.8-4-7.1l-0.1,0c0.2,2.7,0.2,5.3,0.2,8.8v9.1H118.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M157.5,218.3c0,7.3-4.5,11.2-9.9,11.2c-5.6,0-9.6-4.4-9.6-10.8c0-6.8,4.2-11.2,9.9-11.2 C153.8,207.5,157.5,211.9,157.5,218.3z M141,218.6c0,4.6,2.5,8.6,6.8,8.6c4.4,0,6.8-4,6.8-8.9c0-4.2-2.2-8.7-6.8-8.7 C143.3,209.7,141,213.9,141,218.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M164.4,210.2h-6.5v-2.3h15.8v2.3h-6.5v19h-2.8V210.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M182.8,207.8h11.5v2.3h-8.7v7.1h8.1v2.3h-8.1v9.7h-2.8V207.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M216.4,218.3c0,7.3-4.5,11.2-9.9,11.2c-5.6,0-9.6-4.4-9.6-10.8c0-6.8,4.2-11.2,9.9-11.2 C212.7,207.5,216.4,211.9,216.4,218.3z M199.9,218.6c0,4.6,2.5,8.6,6.8,8.6c4.4,0,6.8-4,6.8-8.9c0-4.2-2.2-8.7-6.8-8.7 C202.2,209.7,199.9,213.9,199.9,218.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M222.8,207.8v12.6c0,4.8,2.1,6.8,5,6.8c3.2,0,5.2-2.1,5.2-6.8v-12.6h2.8v12.4c0,6.6-3.5,9.2-8.1,9.2 c-4.4,0-7.7-2.5-7.7-9.1v-12.6H222.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M240.5,229.2v-21.3h3l6.8,10.8c1.6,2.5,2.8,4.7,3.8,6.9l0.1,0c-0.3-2.8-0.3-5.4-0.3-8.8v-8.9h2.6v21.3 h-2.8l-6.8-10.8c-1.5-2.4-2.9-4.8-4-7.1l-0.1,0c0.2,2.7,0.2,5.3,0.2,8.8v9.1H240.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M261.3,208.1c1.7-0.3,3.7-0.4,5.9-0.4c4,0,6.8,0.9,8.6,2.7c1.9,1.7,3,4.2,3,7.7c0,3.5-1.1,6.3-3.1,8.3 c-2,2-5.3,3.1-9.4,3.1c-2,0-3.6-0.1-5-0.3V208.1z M264.1,227c0.7,0.1,1.7,0.2,2.8,0.2c5.9,0,9.1-3.3,9.1-9.1 c0-5-2.8-8.2-8.6-8.2c-1.4,0-2.5,0.1-3.2,0.3V227z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M44.6,208.1c1.3-0.2,3.1-0.4,5.3-0.4c2.7,0,4.7,0.6,6,1.8c1.2,1,1.9,2.6,1.9,4.5c0,1.9-0.6,3.5-1.6,4.6 c-1.5,1.6-3.8,2.3-6.5,2.3c-0.8,0-1.6,0-2.2-0.2v8.5h-2.8V208.1z M47.4,218.4c0.6,0.2,1.4,0.2,2.3,0.2c3.3,0,5.4-1.6,5.4-4.6 c0-2.8-2-4.2-5-4.2c-1.2,0-2.1,0.1-2.6,0.2V218.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M62.3,222.4l-2.2,6.7h-2.8l7.3-21.3h3.3l7.3,21.3h-2.9l-2.3-6.7H62.3z M69.3,220.3l-2.1-6.1 c-0.5-1.4-0.8-2.7-1.1-3.9H66c-0.3,1.3-0.7,2.6-1.1,3.9l-2.1,6.2H69.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M94,228.2c-1.2,0.4-3.7,1.2-6.6,1.2c-3.2,0-5.9-0.8-8-2.8c-1.8-1.8-3-4.6-3-7.9c0-6.4,4.4-11,11.6-11 c2.5,0,4.4,0.5,5.3,1l-0.7,2.2c-1.1-0.5-2.6-0.9-4.7-0.9c-5.2,0-8.6,3.2-8.6,8.6c0,5.4,3.3,8.6,8.2,8.6c1.8,0,3-0.3,3.7-0.6 v-6.4h-4.3v-2.2h7V228.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M109.2,219.1h-8.3v7.7h9.2v2.3h-12v-21.3h11.5v2.3h-8.8v6.7h8.3V219.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M120.5,229.2v-21.3h3l6.8,10.8c1.6,2.5,2.8,4.7,3.8,6.9l0.1,0c-0.3-2.8-0.3-5.4-0.3-8.8v-8.9h2.6v21.3 h-2.8l-6.8-10.8c-1.5-2.4-2.9-4.8-4-7.1l-0.1,0c0.2,2.7,0.2,5.3,0.2,8.8v9.1H120.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M159.5,218.3c0,7.3-4.5,11.2-9.9,11.2c-5.6,0-9.6-4.4-9.6-10.8c0-6.8,4.2-11.2,9.9-11.2 C155.8,207.5,159.5,211.9,159.5,218.3z M143,218.6c0,4.6,2.5,8.6,6.8,8.6c4.4,0,6.8-4,6.8-8.9c0-4.2-2.2-8.7-6.8-8.7 C145.3,209.7,143,213.9,143,218.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M166.4,210.2h-6.5v-2.3h15.8v2.3h-6.5v19h-2.8V210.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M184.8,207.8h11.5v2.3h-8.7v7.1h8.1v2.3h-8.1v9.7h-2.8V207.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M218.4,218.3c0,7.3-4.5,11.2-9.9,11.2c-5.6,0-9.6-4.4-9.6-10.8c0-6.8,4.2-11.2,9.9-11.2 C214.7,207.5,218.4,211.9,218.4,218.3z M201.9,218.6c0,4.6,2.5,8.6,6.8,8.6c4.4,0,6.8-4,6.8-8.9c0-4.2-2.2-8.7-6.8-8.7 C204.2,209.7,201.9,213.9,201.9,218.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M224.8,207.8v12.6c0,4.8,2.1,6.8,5,6.8c3.2,0,5.2-2.1,5.2-6.8v-12.6h2.8v12.4c0,6.6-3.5,9.2-8.1,9.2 c-4.4,0-7.7-2.5-7.7-9.1v-12.6H224.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M242.5,229.2v-21.3h3l6.8,10.8c1.6,2.5,2.8,4.7,3.8,6.9l0.1,0c-0.3-2.8-0.3-5.4-0.3-8.8v-8.9h2.6v21.3 h-2.8l-6.8-10.8c-1.5-2.4-2.9-4.8-4-7.1l-0.1,0c0.2,2.7,0.2,5.3,0.2,8.8v9.1H242.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M263.3,208.1c1.7-0.3,3.7-0.4,5.9-0.4c4,0,6.8,0.9,8.6,2.7c1.9,1.7,3,4.2,3,7.7c0,3.5-1.1,6.3-3.1,8.3 c-2,2-5.3,3.1-9.4,3.1c-2,0-3.6-0.1-5-0.3V208.1z M266.1,227c0.7,0.1,1.7,0.2,2.8,0.2c5.9,0,9.1-3.3,9.1-9.1 c0-5-2.8-8.2-8.6-8.2c-1.4,0-2.5,0.1-3.2,0.3V227z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M43.6,208.1c1.3-0.2,3.1-0.4,5.3-0.4c2.7,0,4.7,0.6,6,1.8c1.2,1,1.9,2.6,1.9,4.5c0,1.9-0.6,3.5-1.6,4.6 c-1.5,1.6-3.8,2.3-6.5,2.3c-0.8,0-1.6,0-2.2-0.2v8.5h-2.8V208.1z M46.4,218.4c0.6,0.2,1.4,0.2,2.3,0.2c3.3,0,5.4-1.6,5.4-4.6 c0-2.8-2-4.2-5-4.2c-1.2,0-2.1,0.1-2.6,0.2V218.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M61.3,222.4l-2.2,6.7h-2.8l7.3-21.3h3.3l7.3,21.3h-2.9l-2.3-6.7H61.3z M68.3,220.3l-2.1-6.1 c-0.5-1.4-0.8-2.7-1.1-3.9H65c-0.3,1.3-0.7,2.6-1.1,3.9l-2.1,6.2H68.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M93,228.2c-1.2,0.4-3.7,1.2-6.6,1.2c-3.2,0-5.9-0.8-8-2.8c-1.8-1.8-3-4.6-3-7.9c0-6.4,4.4-11,11.6-11 c2.5,0,4.4,0.5,5.3,1l-0.7,2.2c-1.1-0.5-2.6-0.9-4.7-0.9c-5.2,0-8.6,3.2-8.6,8.6c0,5.4,3.3,8.6,8.2,8.6c1.8,0,3-0.3,3.7-0.6 v-6.4h-4.3v-2.2h7V228.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M108.2,219.1h-8.3v7.7h9.2v2.3h-12v-21.3h11.5v2.3h-8.8v6.7h8.3V219.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M119.5,229.2v-21.3h3l6.8,10.8c1.6,2.5,2.8,4.7,3.8,6.9l0.1,0c-0.3-2.8-0.3-5.4-0.3-8.8v-8.9h2.6v21.3 h-2.8l-6.8-10.8c-1.5-2.4-2.9-4.8-4-7.1l-0.1,0c0.2,2.7,0.2,5.3,0.2,8.8v9.1H119.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M158.5,218.3c0,7.3-4.5,11.2-9.9,11.2c-5.6,0-9.6-4.4-9.6-10.8c0-6.8,4.2-11.2,9.9-11.2 C154.8,207.5,158.5,211.9,158.5,218.3z M142,218.6c0,4.6,2.5,8.6,6.8,8.6c4.4,0,6.8-4,6.8-8.9c0-4.2-2.2-8.7-6.8-8.7 C144.3,209.7,142,213.9,142,218.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M165.4,210.2h-6.5v-2.3h15.8v2.3h-6.5v19h-2.8V210.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M183.8,207.8h11.5v2.3h-8.7v7.1h8.1v2.3h-8.1v9.7h-2.8V207.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M217.4,218.3c0,7.3-4.5,11.2-9.9,11.2c-5.6,0-9.6-4.4-9.6-10.8c0-6.8,4.2-11.2,9.9-11.2 C213.7,207.5,217.4,211.9,217.4,218.3z M200.9,218.6c0,4.6,2.5,8.6,6.8,8.6c4.4,0,6.8-4,6.8-8.9c0-4.2-2.2-8.7-6.8-8.7 C203.2,209.7,200.9,213.9,200.9,218.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M223.8,207.8v12.6c0,4.8,2.1,6.8,5,6.8c3.2,0,5.2-2.1,5.2-6.8v-12.6h2.8v12.4c0,6.6-3.5,9.2-8.1,9.2 c-4.4,0-7.7-2.5-7.7-9.1v-12.6H223.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M241.5,229.2v-21.3h3l6.8,10.8c1.6,2.5,2.8,4.7,3.8,6.9l0.1,0c-0.3-2.8-0.3-5.4-0.3-8.8v-8.9h2.6v21.3 h-2.8l-6.8-10.8c-1.5-2.4-2.9-4.8-4-7.1l-0.1,0c0.2,2.7,0.2,5.3,0.2,8.8v9.1H241.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M262.3,208.1c1.7-0.3,3.7-0.4,5.9-0.4c4,0,6.8,0.9,8.6,2.7c1.9,1.7,3,4.2,3,7.7c0,3.5-1.1,6.3-3.1,8.3 c-2,2-5.3,3.1-9.4,3.1c-2,0-3.6-0.1-5-0.3V208.1z M265.1,227c0.7,0.1,1.7,0.2,2.8,0.2c5.9,0,9.1-3.3,9.1-9.1 c0-5-2.8-8.2-8.6-8.2c-1.4,0-2.5,0.1-3.2,0.3V227z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_452_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_510_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1065_",
    className: "st52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_516_",
    className: "st53",
    d: "M102.9,160v-17.5h-9.6v-11h-6v-7h6v-9.1h-5.4v-7h5.4v-5.4H73v-1.2h20.3v-1.4h-21v8.3 h-0.5v3.2h-4.3v-3.2h-5.2V105h-1.5v-7h1.5v-4.7h10V98h21V86.9H59.2l-9.1,13h9.7v1.2H49.2l-1,1.4h9.6v2.5H46.4l-9.6,13.6h17.8 v5.6H32.9l-14.2,20.3v7.8h35.4v1.9H18.7v4.6h63v1.2h-63v4.2h10.7v4.2H18.7v2.6h41.7v3.6H84v7.2H60.4v3.8h32.8v-14.7h9.6v-6.2 H96V160H102.9z M28.4,149.2H24v-4.3h4.3V149.2z M39,146h-7v-7h7V146z M73.7,144.4H61.6v-1.8h-8.9l8.9-13.5v-5.1h12.1V144.4z  M83.9,123.9h-4.3v-4.3h4.3V123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_565_",
    className: "st53",
    d: "M192.2,144.8c0.4-3.3,0.6-6.9,0.6-10.6c0-10-1.4-18.5-4-25.7H158v-4.9h28.7 C180,90.3,168,83.3,151.3,83.3c-9.8,0-18,2.5-24.5,7.2h39.8V93h-42.8c-1.8,1.7-3.5,3.6-5,5.8H129v6.2h-13.7 c-3.6,7.8-5.4,17.6-5.4,29.2c0,2.1,0.1,4.2,0.2,6.1H121V155h-8.7c0.5,1.7,1,3.4,1.6,5h28.7v4.9H116c0.7,1.4,1.4,2.6,2.2,3.9 H162v2.5h-42c7,9.2,17.6,14,31.4,14c23.1,0,37.3-13.6,40.7-38.6h-21.2v-1.9H192.2z M169,95h4.3v4.3H169V95z M167.7,148.5v10 H152v-4.3c-0.2,0-0.4,0-0.7,0c-7.9,0-9.4-7.1-9.4-20.1c0-11.9,1.3-18.7,7.6-19.8v-3.7h19V124H160c0.3,2.3,0.5,5.1,0.5,8.2H172 v3.8h-11.4c-0.1,5.3-0.4,9.5-1.5,12.5H167.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_651_",
    x: 261,
    y: 93,
    className: "st53",
    width: 14.2,
    height: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_622_",
    className: "st53",
    d: "M275.2,142.5V124h-3.7v-7h3.7V108H272v-7h3.2v-5.4H261v18.9h-12.8v-10.8h-0.5v-6.3H245 v-7h2.8v-3.6h-6.6l-3.8,5.5h6.7v1.2h-7.5l-1,1.4h6.5v2.5h-8.3l-4.9,7h17.5v6.8H224l-6.3,9h15V143h-31l-1.1,1.5v0.3h37.6v1.9 h-37.6v4.6h65.3v1.2h-65.3v5.3h25.8v9.2h-25.8v4.1h41.7v6.6h14.8v2.8h-14.8v5.3h32.8v-14.7h9.6v-28.6H275.2z M257,146h-15 v-3.5h-7.3l7.3-11.2v-6.9h15V146z M268.1,116.4h-4.3V112h4.3V116.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_658_",
    x: 261,
    y: 86.9,
    className: "st53",
    width: 14.2,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1073_",
    x: 4.8,
    y: 139,
    className: "st53",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1072_",
    x: 95.2,
    y: 105,
    className: "st53",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1071_",
    x: 104,
    y: 109,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_471_",
    x: 198.5,
    y: 122,
    className: "st53",
    width: 2.7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1069_",
    x: 279.3,
    y: 97.5,
    className: "st53",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1068_",
    x: 288.2,
    y: 101.5,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1067_",
    x: 207.1,
    y: 115.5,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1066_",
    x: 186.5,
    y: 95,
    className: "st53",
    width: 4.3,
    height: 4.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1036_",
    className: "st54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_522_",
    className: "st53",
    d: "M103.1,160v-17.5h-9.6v-11h-6v-7h6v-9.1h-5.4v-7h5.4v-5.4H73.2v-1.2h20.3v-1.4H72.3v8.3 H72v3.2h-4.3v-3.2h-5.4V105H61v-7h1.3v-4.7h10V98h21.2V86.9H59.4l-9.1,13H60v1.2H49.4l-1,1.4H58v2.5H46.7l-9.6,13.6h17.6v5.6 H33.2L19,144.5v7.8h35.4v1.9H19v4.6h63v1.2H19v4.2h10.5v4.2H19v2.6h41.7v3.6H84v7.2H60.7v3.8h32.8v-14.7h9.6v-6.2h-6.8V160 H103.1z M28.6,149.2h-4.3v-4.3h4.3V149.2z M39.2,146h-7v-7h7V146z M73.7,144.4H61.6v-1.8h-8.6l8.6-13.2v-5.5h12.1V144.4z  M84.2,123.9h-4.3v-4.3h4.3V123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_569_",
    className: "st53",
    d: "M192.4,144.8c0.4-3.3,0.6-6.9,0.6-10.6c0-10-1.4-18.5-4-25.7h-30.8v-4.9h28.7 c-6.7-13.3-18.7-20.3-35.4-20.3c-9.8,0-18,2.5-24.5,7.2h39.8V93H124c-1.8,1.7-3.5,3.6-5,5.8h9.9v6.2h-13.5 c-3.6,7.8-5.4,17.6-5.4,29.2c0,2.1,0.1,4.2,0.2,6.1H121V155h-8.4c0.5,1.7,1,3.4,1.6,5h28.7v4.9h-26.6c0.7,1.4,1.4,2.6,2.2,3.9 h43.8v2.5h-42c7,9.2,17.6,14,31.4,14c23.1,0,37.3-13.6,40.7-38.6H171v-1.9H192.4z M169.3,95h4.3v4.3h-4.3V95z M167.7,148.5v10 H152v-4.3c-0.1,0-0.3,0-0.4,0c-7.9,0-9.4-7.1-9.4-20.1c0-11.7,1.2-18.5,7.4-19.7v-3.7h19V124h-8.2c0.3,2.3,0.5,5.1,0.5,8.2 H172v3.8h-11.2c-0.1,5.3-0.4,9.5-1.5,12.5H167.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_659_",
    x: 261,
    y: 86.9,
    className: "st53",
    width: 14.5,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_660_",
    x: 261,
    y: 93,
    className: "st53",
    width: 14.5,
    height: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_630_",
    className: "st53",
    d: "M275.4,142.5V124h-3.7v-7h3.7V108h-3.2v-7h3.2v-5.4H261v18.9h-12.8v-10.8h-0.5v-6.3 h-2.5v-7h2.5v-3.6h-6.4l-3.8,5.5h6.7v1.2h-7.5l-1,1.4h6.5v2.5h-8.3l-4.9,7h17.3v6.8h-22l-6.3,9h14.8V143H202l-1.1,1.5v0.3 h37.6v1.9h-37.6v4.6h65.3v1.2h-65.3v5.3h25.6v9.2h-25.6v4.1h41.7v6.6h14.6v2.8h-14.6v5.3h32.8v-14.7h9.6v-28.6H275.4z  M257,146h-15v-3.5h-7.1l7.1-10.8v-7.2h15V146z M268.3,116.4H264V112h4.3V116.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1044_",
    x: 5.1,
    y: 139,
    className: "st53",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1043_",
    x: 95.4,
    y: 105,
    className: "st53",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1042_",
    x: 104.3,
    y: 109,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_472_",
    x: 198.7,
    y: 122,
    className: "st53",
    width: 2.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1040_",
    x: 279.6,
    y: 97.5,
    className: "st53",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1039_",
    x: 288.4,
    y: 101.5,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1038_",
    x: 207.4,
    y: 115.5,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1037_",
    x: 186.8,
    y: 95,
    className: "st53",
    width: 4.3,
    height: 4.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1007_",
    className: "st55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_528_",
    className: "st53",
    d: "M103.3,160v-17.5h-9.6v-11h-6v-7h6v-9.1h-5.4v-7h5.4v-5.4H73.4v-1.2h20.3v-1.4H72.3v8.3 h-0.1v3.2h-4.3v-3.2h-5.6V105h-1.1v-7h1.1v-4.7h10V98h21.4V86.9H59.6l-9.1,13h9.7v1.2H49.6l-1,1.4h9.6v2.5H46.9l-9.6,13.6 h17.4v5.6H33.4l-14.2,20.3v7.8h35.4v1.9H19.2v4.6h63v1.2h-63v4.2h10.3v4.2H19.2v2.6h41.7v3.6H84v7.2H60.9v3.8h32.8v-14.7h9.6 v-6.2h-6.8V160H103.3z M28.8,149.2h-4.3v-4.3h4.3V149.2z M39.4,146h-7v-7h7V146z M73.7,144.4H61.6v-1.8h-8.4l8.4-12.9v-5.8 h12.1V144.4z M84.4,123.9h-4.3v-4.3h4.3V123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_573_",
    className: "st53",
    d: "M192.6,144.8c0.4-3.3,0.6-6.9,0.6-10.6c0-10-1.4-18.5-4-25.7h-30.8v-4.9h28.7 c-6.7-13.3-18.7-20.3-35.4-20.3c-9.8,0-18,2.5-24.5,7.2h39.8V93h-42.8c-1.8,1.7-3.5,3.6-5,5.8h9.7v6.2h-13.2 c-3.6,7.8-5.4,17.6-5.4,29.2c0,2.1,0.1,4.2,0.2,6.1H121V155h-8.2c0.5,1.7,1,3.4,1.6,5H143v4.9h-26.6c0.7,1.4,1.4,2.6,2.2,3.9 h43.8v2.5h-42c7,9.2,17.6,14,31.4,14c23.1,0,37.3-13.6,40.7-38.6h-21.2v-1.9H192.6z M169.5,95h4.3v4.3h-4.3V95z M167.7,148.5 v10H152v-4.2c-0.1,0-0.1,0-0.2,0c-7.9,0-9.4-7.1-9.4-20.1c0-11.6,1.2-18.4,7.1-19.7v-3.7h19V124h-8c0.3,2.3,0.5,5.1,0.5,8.2 H172v3.8H161c-0.1,5.3-0.4,9.5-1.5,12.5H167.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_579_",
    x: 261,
    y: 93,
    className: "st53",
    width: 14.7,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_580_",
    x: 261,
    y: 86.9,
    className: "st53",
    width: 14.7,
    height: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_636_",
    className: "st53",
    d: "M275.6,142.5V124h-3.7v-7h3.7V108h-3.2v-7h3.2v-5.4H261v18.9h-12.8v-10.8h-0.5v-6.3 h-2.3v-7h2.3v-3.6h-6.2l-3.8,5.5h6.7v1.2h-7.5l-1,1.4h6.5v2.5h-8.3l-4.9,7h17v6.8h-21.8l-6.3,9h14.6V143h-30.5l-1.1,1.5v0.3 h37.6v1.9h-37.6v4.6h65.3v1.2h-65.3v5.3h25.3v9.2h-25.3v4.1h41.7v6.6h14.4v2.8h-14.4v5.3h32.8v-14.7h9.6v-28.6H275.6z  M257,146h-15v-3.5h-6.9l6.9-10.5v-7.6h15V146z M268.6,116.4h-4.3V112h4.3V116.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1015_",
    x: 5.3,
    y: 139,
    className: "st53",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1014_",
    x: 95.6,
    y: 105,
    className: "st53",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1013_",
    x: 104.5,
    y: 109,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_473_",
    x: 198.9,
    y: 122,
    className: "st53",
    width: 2.3,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1011_",
    x: 279.8,
    y: 97.5,
    className: "st53",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1010_",
    x: 288.6,
    y: 101.5,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1009_",
    x: 207.6,
    y: 115.5,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1008_",
    x: 187,
    y: 95,
    className: "st53",
    width: 4.3,
    height: 4.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_978_",
    className: "st56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_534_",
    className: "st53",
    d: "M103.5,160v-17.5h-9.6v-11h-6v-7h6v-9.1h-5.4v-7h5.4v-5.4H73.6v-1.2h20.3v-1.4H72.3v7.2 h0.2v4.3h-4.3v-3.2h-5.8V105h-0.8v-7h0.8v-4.7h10V98h21.6V86.9H59.8l-9.1,13h9.7v1.2H49.8l-1,1.4h9.6v2.5H47.1l-9.6,13.6h17.2 v5.6H33.6l-14.2,20.3v7.8h35.4v1.9H19.4v4.6h63v1.2h-63v4.2h10.1v4.2H19.4v2.6h41.7v3.6H84v7.2H61.1v3.8h32.8v-14.7h9.6v-6.2 h-6.8V160H103.5z M29,149.2h-4.3v-4.3H29V149.2z M39.6,146h-7v-7h7V146z M73.7,144.4H61.6v-1.8h-8.2l8.2-12.5v-6.1h12.1V144.4 z M84.6,123.9h-4.3v-4.3h4.3V123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_577_",
    className: "st53",
    d: "M192.9,144.8c0.4-3.3,0.6-6.9,0.6-10.6c0-10-1.4-18.5-4-25.7h-30.8v-4.9h28.7 c-6.7-13.3-18.7-20.3-35.4-20.3c-9.8,0-18,2.5-24.5,7.2h39.8V93h-42.8c-1.8,1.7-3.5,3.6-5,5.8h9.5v6.2h-13 c-3.6,7.8-5.4,17.6-5.4,29.2c0,2.1,0.1,4.2,0.2,6.1H121V155h-8c0.5,1.7,1,3.4,1.6,5h28.7v4.9h-26.6c0.7,1.4,1.4,2.6,2.2,3.9 h43.8v2.5h-42c7,9.2,17.6,14,31.4,14c23.1,0,37.3-13.6,40.7-38.6h-21.2v-1.9H192.9z M169.7,95h4.3v4.3h-4.3V95z M167.7,148.5 v10H152v-4.2c-7.9,0-9.4-7.1-9.4-20.1c0-11.4,1.2-18.2,6.9-19.6v-3.8h19V124h-7.8c0.3,2.3,0.5,5.1,0.5,8.2H172v3.8h-10.7 c-0.1,5.3-0.4,9.5-1.5,12.5H167.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_587_",
    x: 261,
    y: 93,
    className: "st53",
    width: 14.9,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_588_",
    x: 261,
    y: 86.9,
    className: "st53",
    width: 14.9,
    height: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_639_",
    className: "st53",
    d: "M275.9,142.5V124h-3.7v-7h3.7V108h-3.2v-7h3.2v-5.4H261v18.9h-12.8v-10.8h-0.5v-6.3 h-2.1v-7h2.1v-3.6h-6l-3.8,5.5h6.7v1.2h-7.5l-1,1.4h6.5v2.5h-8.3l-4.9,7h16.8v6.8h-21.5l-6.3,9h14.4V143h-30.3l-1.1,1.5v0.3 h37.6v1.9h-37.6v4.6h65.3v1.2h-65.3v5.3h25.1v9.2h-25.1v4.1H243v6.6h14.2v2.8H243v5.3h32.8v-14.7h9.6v-28.6H275.9z M257,146 h-15v-3.5h-6.6l6.6-10.1v-7.9h15V146z M268.8,116.4h-4.3V112h4.3V116.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_986_",
    x: 5.5,
    y: 139,
    className: "st53",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_985_",
    x: 95.8,
    y: 105,
    className: "st53",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_984_",
    x: 104.7,
    y: 109,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_559_",
    x: 199.1,
    y: 122,
    className: "st53",
    width: 2.1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_982_",
    x: 280,
    y: 97.5,
    className: "st53",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_981_",
    x: 288.9,
    y: 101.5,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_980_",
    x: 207.8,
    y: 115.5,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_979_",
    x: 187.2,
    y: 95,
    className: "st53",
    width: 4.3,
    height: 4.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_949_",
    className: "st57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_545_",
    className: "st53",
    d: "M103.7,160v-17.5h-9.6v-11h-6v-7h6v-9.1h-5.4v-7h5.4v-5.4H73.9v-1.2h20.3v-1.4H72.3v7.2 h0.4v4.3h-4.3v-3.2h-6.1V105h-0.6v-7h0.6v-4.7h10V98h21.9V86.9H60l-9.1,13h9.7v1.2H50.1l-1,1.4h9.6v2.5H47.3l-9.6,13.6h16.9 v5.6H33.8l-14.2,20.3v7.8H55v1.9H19.6v4.6h63v1.2h-63v4.2h9.8v4.2h-9.8v2.6h41.7v3.6H84v7.2H61.3v3.8h32.8v-14.7h9.6v-6.2 h-6.8V160H103.7z M29.3,149.2h-4.3v-4.3h4.3V149.2z M39.9,146h-7v-7h7V146z M73.7,144.4H61.6v-1.8h-8l8-12.2v-6.5h12.1V144.4z  M84.8,123.9h-4.3v-4.3h4.3V123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_476_",
    className: "st53",
    d: "M193.1,144.8c0.4-3.3,0.6-6.9,0.6-10.6c0-10-1.4-18.5-4-25.7h-30.8v-4.9h28.7 c-6.7-13.3-18.7-20.3-35.4-20.3c-9.8,0-18,2.5-24.5,7.2h39.8V93h-42.8c-1.8,1.7-3.5,3.6-5,5.8h9.2v6.2h-12.8 c-3.6,7.8-5.4,17.6-5.4,29.2c0,2.1,0.1,4.2,0.2,6.1h10V155h-7.8c0.5,1.7,1,3.4,1.6,5h28.7v4.9h-26.6c0.7,1.4,1.4,2.6,2.2,3.9 h43.8v2.5h-42c7,9.2,17.6,14,31.4,14c23.1,0,37.3-13.6,40.7-38.6h-21.2v-1.9H193.1z M169.9,95h4.3v4.3h-4.3V95z M167.7,148.5 v10H152v-4.2c-7.7-0.1-9.2-7.2-9.2-20.1c0-11.3,1.1-18.1,6.7-19.6v-3.8h19V124h-7.5c0.3,2.3,0.5,5.1,0.5,8.2H172v3.8h-10.5 c-0.1,5.3-0.4,9.5-1.5,12.5H167.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_645_",
    className: "st53",
    d: "M276.1,142.5V124h-3.7v-7h3.7V108h-3.2v-7h3.2v-5.4H261v18.9h-12.8v-10.8h-0.5v-6.3 h-1.9v-7h1.9v-3.6H242l-3.8,5.5h6.7v1.2h-7.5l-1,1.4h6.5v2.5h-8.3l-4.9,7h16.6v6.8h-21.3l-6.3,9h14.1V143h-30.1l-1.1,1.5v0.3 h37.6v1.9h-37.6v4.6h65.3v1.2h-65.3v5.3h24.9v9.2h-24.9v4.1h41.7v6.6h14v2.8h-14v5.3h32.8v-14.7h9.6v-28.6H276.1z M257,146 h-15v-3.5h-6.4l6.4-9.8v-8.2h15V146z M269,116.4h-4.3V112h4.3V116.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_601_",
    x: 261,
    y: 93,
    className: "st53",
    width: 15.1,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_602_",
    x: 261,
    y: 86.9,
    className: "st53",
    width: 15.1,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_957_",
    x: 5.7,
    y: 139,
    className: "st53",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_956_",
    x: 96.1,
    y: 105,
    className: "st53",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_955_",
    x: 104.9,
    y: 109,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_560_",
    x: 199.4,
    y: 122,
    className: "st53",
    width: 1.9,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_953_",
    x: 280.2,
    y: 97.5,
    className: "st53",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_952_",
    x: 289.1,
    y: 101.5,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_951_",
    x: 208,
    y: 115.5,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_950_",
    x: 187.4,
    y: 95,
    className: "st53",
    width: 4.3,
    height: 4.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_920_",
    className: "st58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_551_",
    className: "st53",
    d: "M104,160v-17.5h-9.6v-11h-6v-7h6v-9.1H89v-7h5.4v-5.4H74.1v-1.2h20.3v-1.4H72.3v7.2h0.6 v4.3h-4.3v-3.2h-6.3V105h-0.4v-7h0.4v-4.7h10V98h22.1V86.9H60.3l-9.1,13h9.7v1.2H50.3l-1,1.4h9.6v2.5H47.6L38,118.6h16.7v5.6 H34.1l-14.2,20.3v7.8h35.4v1.9H19.9v4.6h63v1.2h-63v4.2h9.6v4.2h-9.6v2.6h41.7v3.6H84v7.2H61.5v3.8h32.8v-14.7h9.6v-6.2h-6.8 V160H104z M29.5,149.2h-4.3v-4.3h4.3V149.2z M40.1,146h-7v-7h7V146z M73.7,144.4H61.6v-1.8h-7.8l7.8-11.8v-6.8h12.1V144.4z  M85.1,123.9h-4.3v-4.3h4.3V123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_501_",
    className: "st53",
    d: "M193.3,144.8c0.4-3.3,0.6-6.9,0.6-10.6c0-10-1.4-18.5-4-25.7h-30.8v-4.9h28.7 c-6.7-13.3-18.7-20.3-35.4-20.3c-9.8,0-18,2.5-24.5,7.2h39.8V93h-42.8c-1.8,1.7-3.5,3.6-5,5.8h9v6.2h-12.6 c-3.6,7.8-5.4,17.6-5.4,29.2c0,2.1,0.1,4.2,0.2,6.1h9.8V155h-7.6c0.5,1.7,1,3.4,1.6,5h28.7v4.9h-26.6c0.7,1.4,1.4,2.6,2.2,3.9 h43.8v2.5h-42c7,9.2,17.6,14,31.4,14c23.1,0,37.3-13.6,40.7-38.6h-21.2v-1.9H193.3z M170.2,95h4.3v4.3h-4.3V95z M167.7,148.5 v10H152v-4.3c-7.5-0.3-9-7.3-9-20c0-11.1,1.1-17.8,6.5-19.5v-3.9h19V124h-7.3c0.3,2.3,0.5,5.1,0.5,8.2H172v3.8h-10.3 c-0.1,5.3-0.4,9.5-1.5,12.5H167.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_603_",
    x: 261,
    y: 93,
    className: "st53",
    width: 15.4,
    height: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_650_",
    className: "st53",
    d: "M276.3,142.5V124h-3.7v-7h3.7V108h-3.2v-7h3.2v-5.4H261v18.9h-12.8v-10.8h-0.5v-6.3 h-1.6v-7h1.6v-3.6h-5.5l-3.8,5.5h6.7v1.2h-7.5l-1,1.4h6.5v2.5h-8.3l-4.9,7h16.4v6.8h-21.1l-6.3,9h13.9V143h-29.9l-1.1,1.5v0.3 h37.6v1.9h-37.6v4.6h65.3v1.2h-65.3v5.3h24.7v9.2h-24.7v4.1h41.7v6.6h13.7v2.8h-13.7v5.3h32.8v-14.7h9.6v-28.6H276.3z  M257,146h-15v-3.5h-6.2l6.2-9.5v-8.6h15V146z M269.2,116.4h-4.3V112h4.3V116.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_610_",
    x: 261,
    y: 86.9,
    className: "st53",
    width: 15.4,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_928_",
    x: 5.9,
    y: 139,
    className: "st53",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_927_",
    x: 96.3,
    y: 105,
    className: "st53",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_926_",
    x: 105.1,
    y: 109,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_561_",
    x: 199.6,
    y: 122,
    className: "st53",
    width: 1.6,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_924_",
    x: 280.4,
    y: 97.5,
    className: "st53",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_923_",
    x: 289.3,
    y: 101.5,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_922_",
    x: 208.2,
    y: 115.5,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_921_",
    x: 187.7,
    y: 95,
    className: "st53",
    width: 4.3,
    height: 4.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_891_",
    className: "st59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_480_",
    className: "st53",
    d: "M104.2,160v-17.5h-9.6v-11h-6v-7h6v-9.1h-5.4v-7h5.4v-5.4H74.3v-1.2h20.3v-1.4H72.3v7.2 h0.8v4.3h-4.3v-3.2h-6.5V105h-0.2v-7h0.2v-4.7h10V98h22.3V86.9H60.5l-9.1,13h9.7v1.2H50.5l-1,1.4h9.6v2.5H47.8l-9.6,13.6h16.5 v5.6H34.3l-14.2,20.3v7.8h35.4v1.9H20.1v4.6h63v1.2h-63v4.2h9.4v4.2h-9.4v2.6h41.7v3.6H84v7.2H61.8v3.8h32.8v-14.7h9.6v-6.2 h-6.8V160H104.2z M29.7,149.2h-4.3v-4.3h4.3V149.2z M40.3,146h-7v-7h7V146z M73.7,144.4H61.6v-1.8h-7.5l7.5-11.5v-7.2h12.1 V144.4z M85.3,123.9H81v-4.3h4.3V123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_505_",
    className: "st53",
    d: "M193.5,144.8c0.4-3.3,0.6-6.9,0.6-10.6c0-10-1.4-18.5-4-25.7h-30.8v-4.9H188 c-6.7-13.3-18.7-20.3-35.4-20.3c-9.8,0-18,2.5-24.5,7.2H168V93h-42.8c-1.8,1.7-3.5,3.6-5,5.8h8.8v6.2h-12.3 c-3.6,7.8-5.4,17.6-5.4,29.2c0,2.1,0.1,4.2,0.2,6.1h9.6V155h-7.3c0.5,1.7,1,3.4,1.6,5h28.7v4.9h-26.6c0.7,1.4,1.4,2.6,2.2,3.9 h43.8v2.5h-42c7,9.2,17.6,14,31.4,14c23.1,0,37.3-13.6,40.7-38.6h-21.2v-1.9H193.5z M170.4,95h4.3v4.3h-4.3V95z M172,136 h-10.1c-0.1,5.3-0.4,9.5-1.5,12.5h7.3v10H152v-4.3c-7.3-0.4-8.7-7.4-8.7-20c0-11,1.1-17.6,6.2-19.4v-4h19V124h-7.1 c0.3,2.3,0.5,5.1,0.5,8.2H172V136z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_611_",
    x: 261,
    y: 93,
    className: "st53",
    width: 15.6,
    height: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_624_",
    className: "st53",
    d: "M276.5,142.5V124h-3.7v-7h3.7V108h-3.2v-7h3.2v-5.4H261v18.9h-12.8v-10.8h-0.5v-6.3 h-1.4v-7h1.4v-3.6h-5.3l-3.8,5.5h6.7v1.2h-7.5l-1,1.4h6.5v2.5H235l-4.9,7h16.1v6.8h-20.9l-6.3,9h13.7V143h-29.6l-1.1,1.5v0.3 h37.6v1.9H202v4.6h65.3v1.2H202v5.3h24.4v9.2H202v4.1h41.7v6.6h13.5v2.8h-13.5v5.3h32.8v-14.7h9.6v-28.6H276.5z M257,146h-15 v-3.5h-6l6-9.1v-8.9h15V146z M269.4,116.4h-4.3V112h4.3V116.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_618_",
    x: 261,
    y: 86.9,
    className: "st53",
    width: 15.6,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_899_",
    x: 6.2,
    y: 139,
    className: "st53",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_898_",
    x: 96.5,
    y: 105,
    className: "st53",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_897_",
    x: 105.4,
    y: 109,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_562_",
    x: 199.8,
    y: 122,
    className: "st53",
    width: 1.4,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_895_",
    x: 280.7,
    y: 97.5,
    className: "st53",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_894_",
    x: 289.5,
    y: 101.5,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_893_",
    x: 208.5,
    y: 115.5,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_892_",
    x: 187.9,
    y: 95,
    className: "st53",
    width: 4.3,
    height: 4.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_862_",
    className: "st60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_483_",
    className: "st53",
    d: "M104.4,160v-17.5h-9.6v-11h-6v-7h6v-9.1h-5.4v-7h5.4v-5.4H74.5v-1.2h20.3v-1.4H72.3v7.2 h1.1v4.3H69v-3.2h-6.7V93.3h10V98h22.5V86.9H60.7l-9.1,13h9.7v1.2H50.7l-1,1.4h9.6v2.5H48l-9.6,13.6h16.3v5.6H34.5l-14.2,20.3 v7.8h35.4v1.9H20.3v4.6h63v1.2h-63v4.2h9.2v4.2h-9.2v2.6H62v3.6h22v7.2H62v3.8h32.8v-14.7h9.6v-6.2h-6.8V160H104.4z  M29.9,149.2h-4.3v-4.3h4.3V149.2z M40.5,146h-7v-7h7V146z M73.7,144.4H61.6v-1.8h-7.3l7.3-11.2v-7.5h12.1V144.4z M85.5,123.9 h-4.3v-4.3h4.3V123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_509_",
    className: "st53",
    d: "M193.7,144.8c0.4-3.3,0.6-6.9,0.6-10.6c0-10-1.4-18.5-4-25.7h-30.8v-4.9h28.7 c-6.7-13.3-18.7-20.3-35.4-20.3c-9.8,0-18,2.5-24.5,7.2h39.8V93h-42.8c-1.8,1.7-3.5,3.6-5,5.8h8.6v6.2h-12.1 c-3.6,7.8-5.4,17.6-5.4,29.2c0,2.1,0.1,4.2,0.2,6.1h9.4V155h-7.1c0.5,1.7,1,3.4,1.6,5h28.7v4.9h-26.6c0.7,1.4,1.4,2.6,2.2,3.9 h43.8v2.5h-42c7,9.2,17.6,14,31.4,14c23.1,0,37.3-13.6,40.7-38.6h-21.2v-1.9H193.7z M170.6,95h4.3v4.3h-4.3V95z M172,136h-9.8 c-0.1,5.3-0.4,9.5-1.5,12.5h7.1v10H152v-4.3c-7.1-0.5-8.5-7.5-8.5-20c0-10.8,1.1-17.5,6-19.4v-4.1h19V124h-6.9 c0.3,2.3,0.5,5.1,0.5,8.2h9.8V136z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_619_",
    x: 261,
    y: 93,
    className: "st53",
    width: 15.8,
    height: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_592_",
    className: "st53",
    d: "M276.8,142.5V124H273v-7h3.7V108h-3.2v-7h3.2v-5.4H261v18.9h-12.8v-10.8h-0.5v-6.3h-1.2 v-7h1.2v-3.6h-5.1l-3.8,5.5h6.7v1.2h-7.5l-1,1.4h6.5v2.5h-8.3l-4.9,7h15.9v6.8h-20.7l-6.3,9h13.5V143h-29.4l-1.1,1.5v0.3h37.6 v1.9h-37.6v4.6h65.3v1.2h-65.3v5.3h24.2v9.2h-24.2v4.1h41.7v6.6h13.3v2.8h-13.3v5.3h32.8v-14.7h9.6v-28.6H276.8z M257,146h-15 v-3.5h-5.7l5.7-8.8v-9.3h15V146z M269.7,116.4h-4.3V112h4.3V116.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_626_",
    x: 261,
    y: 86.9,
    className: "st53",
    width: 15.8,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_870_",
    x: 6.4,
    y: 139,
    className: "st53",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_869_",
    x: 96.7,
    y: 105,
    className: "st53",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_868_",
    x: 105.6,
    y: 109,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_581_",
    x: 200,
    y: 122,
    className: "st53",
    width: 1.2,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_866_",
    x: 280.9,
    y: 97.5,
    className: "st53",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_865_",
    x: 289.8,
    y: 101.5,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_864_",
    x: 208.7,
    y: 115.5,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_863_",
    x: 188.1,
    y: 95,
    className: "st53",
    width: 4.3,
    height: 4.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_833_",
    className: "st61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_489_",
    className: "st53",
    d: "M104.6,160v-17.5H95v-11h-6v-7h6v-9.1h-5.4v-7H95v-5.4H74.7v-1.2H95v-1.4H72.3v7.2h1.3 v4.3h-4.3v-3.2h-6.9V93.3h10V98H95V86.9H60.9l-9.1,13h9.7v1.2H50.9l-1,1.4h9.6v2.5H48.2l-9.6,13.6h16v5.6h-20l-14.2,20.3v7.8 h35.4v1.9H20.5v4.6h63v1.2h-63v4.2h8.9v4.2h-8.9v2.6h41.7v3.6H84v7.2H62.2v3.8H95v-14.7h9.6v-6.2h-6.8V160H104.6z M30.2,149.2 h-4.3v-4.3h4.3V149.2z M40.7,146h-7v-7h7V146z M73.7,144.4H61.6v-1.8h-7.1l7.1-10.8v-7.8h12.1V144.4z M85.7,123.9h-4.3v-4.3 h4.3V123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_541_",
    className: "st53",
    d: "M194,144.8c0.4-3.3,0.6-6.9,0.6-10.6c0-10-1.4-18.5-4-25.7h-30.8v-4.9h28.7 c-6.7-13.3-18.7-20.3-35.4-20.3c-9.8,0-18,2.5-24.5,7.2h39.8V93h-42.8c-1.8,1.7-3.5,3.6-5,5.8h8.3v6.2h-11.9 c-3.6,7.8-5.4,17.6-5.4,29.2c0,2.1,0.1,4.2,0.2,6.1h9.1V155h-6.9c0.5,1.7,1,3.4,1.6,5h28.7v4.9h-26.6c0.7,1.4,1.4,2.6,2.2,3.9 h43.8v2.5h-42c7,9.2,17.6,14,31.4,14c23.1,0,37.3-13.6,40.7-38.6h-21.2v-1.9H194z M170.8,95h4.3v4.3h-4.3V95z M172,136h-9.6 c-0.1,5.3-0.4,9.5-1.5,12.5h6.8v10H152v-4.3c-6.9-0.7-8.3-7.6-8.3-20c0-10.6,1-17.3,5.8-19.3v-4.2h19V124h-6.7 c0.3,2.3,0.5,5.1,0.5,8.2h9.6V136z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_627_",
    x: 261,
    y: 93,
    className: "st53",
    width: 16,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_628_",
    x: 261,
    y: 86.9,
    className: "st53",
    width: 16,
    height: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_597_",
    className: "st53",
    d: "M277,142.5V124h-3.7v-7h3.7V108h-3.2v-7h3.2v-5.4h-16v18.9h-12.8v-10.8h-0.5v-6.3h-1v-7 h1v-3.6h-4.8l-3.8,5.5h6.7v1.2h-7.5l-1,1.4h6.5v2.5h-8.3l-4.9,7h15.7v6.8h-20.4l-6.3,9h13.2V143h-29.2l-1.1,1.5v0.3H240v1.9 h-37.6v4.6h65.3v1.2h-65.3v5.3h24v9.2h-24v4.1h41.7v6.6h13.1v2.8h-13.1v5.3H277v-14.7h9.6v-28.6H277z M257,146h-15v-3.5h-5.5 l5.5-8.4v-9.6h15V146z M269.9,116.4h-4.3V112h4.3V116.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_841_",
    x: 6.6,
    y: 139,
    className: "st53",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_840_",
    x: 97,
    y: 105,
    className: "st53",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_839_",
    x: 105.8,
    y: 109,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_582_",
    x: 200.2,
    y: 122,
    className: "st53",
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_837_",
    x: 281.1,
    y: 97.5,
    className: "st53",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_836_",
    x: 290,
    y: 101.5,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_835_",
    x: 208.9,
    y: 115.5,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_834_",
    x: 188.3,
    y: 95,
    className: "st53",
    width: 4.3,
    height: 4.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_804_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_495_",
    className: "st53",
    d: "M104.9,160v-17.5h-9.6v-11h-6v-7h6v-9.1h-5.4v-7h5.4v-5.4H75v-1.2h20.3v-1.4h-23v7.2 h1.5v4.3h-4.3v-3.2h-7.2V93.3h10V98h23V86.9H61.2l-9.1,13h9.7v1.2H51.2l-1,1.4h9.6v2.5H48.4l-9.6,13.6h15.8v5.6H34.9 l-14.2,20.3v7.8h35.4v1.9H20.7v4.6h63v1.2h-63v4.2h8.7v4.2h-8.7v2.6h41.7v3.6H84v7.2H62.4v3.8h32.8v-14.7h9.6v-6.2H98V160 H104.9z M30.4,149.2H26v-4.3h4.3V149.2z M41,146h-7v-7h7V146z M73.7,144.4H61.6v-1.8h-6.9l6.9-10.5v-8.2h12.1V144.4z  M85.9,123.9h-4.3v-4.3h4.3V123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_557_",
    className: "st53",
    d: "M194.2,144.8c0.4-3.3,0.6-6.9,0.6-10.6c0-10-1.4-18.5-4-25.7H160v-4.9h28.7 C182,90.3,170,83.3,153.3,83.3c-9.8,0-18,2.5-24.5,7.2h39.8V93h-42.8c-1.8,1.7-3.5,3.6-5,5.8h8.1v6.2h-11.7 c-3.6,7.8-5.4,17.6-5.4,29.2c0,2.1,0.1,4.2,0.2,6.1h8.9V155h-6.7c0.5,1.7,1,3.4,1.6,5h28.7v4.9H118c0.7,1.4,1.4,2.6,2.2,3.9 H164v2.5h-42c7,9.2,17.6,14,31.4,14c23.1,0,37.3-13.6,40.7-38.6h-21.2v-1.9H194.2z M171,95h4.3v4.3H171V95z M172,136h-9.4 c-0.1,5.3-0.4,9.5-1.5,12.5h6.6v10H152v-4.3c-6.7-0.8-8.1-7.8-8.1-20c0-10.5,1-17.1,5.6-19.2v-4.2h19V124H162 c0.3,2.3,0.5,5.1,0.5,8.2h9.4V136z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_635_",
    x: 261,
    y: 93,
    className: "st53",
    width: 16.2,
    height: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_605_",
    className: "st53",
    d: "M277.2,142.5V124h-3.7v-7h3.7V108H274v-7h3.2v-5.4H261v18.9h-12.8v-10.8h-0.5v-6.3H247 v-7h0.8v-3.6h-4.6l-3.8,5.5h6.7v1.2h-7.5l-1,1.4h6.5v2.5h-8.3l-4.9,7h15.5v6.8H226l-6.3,9h13V143h-29l-1.1,1.5v0.3h37.6v1.9 h-37.6v4.6h65.3v1.2h-65.3v5.3h23.8v9.2h-23.8v4.1h41.7v6.6h12.8v2.8h-12.8v5.3h32.8v-14.7h9.6v-28.6H277.2z M257,146h-15 v-3.5h-5.3l5.3-8.1v-9.9h15V146z M270.1,116.4h-4.3V112h4.3V116.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_642_",
    x: 261,
    y: 86.9,
    className: "st53",
    width: 16.2,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_812_",
    x: 6.8,
    y: 139,
    className: "st53",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_811_",
    x: 97.2,
    y: 105,
    className: "st53",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_810_",
    x: 106,
    y: 109,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_583_",
    x: 200.5,
    y: 122,
    className: "st53",
    width: 0.7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_808_",
    x: 281.3,
    y: 97.5,
    className: "st53",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_807_",
    x: 290.2,
    y: 101.5,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_806_",
    x: 209.1,
    y: 115.5,
    className: "st53",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_805_",
    x: 188.5,
    y: 95,
    className: "st53",
    width: 4.3,
    height: 4.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_123_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_918_",
    className: "st52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_278_",
    className: "st62",
    d: "M101.3,131.6h-6v-7h6v-9.1h-5.4v-7h5.4v-5.4H81v-1.2h20.3v-1.4H77.6V98h23.6V88H66.4 L58,99.9h9.7v1.2H57.2l-1,1.4h9.6v2.5H54.4l-27.7,39.5v7.8h35.4v1.9H26.7v4.6h63v1.2h-63v9.2H67v1.9h1.5V185h32.8v-13.9h9.6 v-6.2H104V160h6.8v-17.5h-9.6V131.6z M36.4,149.2H32v-4.3h4.3V149.2z M47,146h-7v-7h7V146z M68.8,98h7v7h-7V98z M70.8,142.5 H60.7l10.1-15.4V142.5z M79.8,112h-1.1v2h-12v-8h12v1.7h1.1V112z M91.9,123.9h-2.5v2.1h-9.2v-7.2h9.2v0.8h2.5V123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_68_",
    className: "st62",
    d: "M200.2,144.8c0.4-3.3,0.6-6.9,0.6-10.6c0-10-1.4-18.5-4-25.7H166v-4.9h28.7 C188,90.3,176,83.3,159.3,83.3c-9.8,0-18,2.5-24.5,7.2h39.8V93h-42.8c-9.1,8.5-14,22.4-14,41.2c0,10,1.4,18.6,4,25.8h28.7v4.9 H149v1.4h-24.3c0.5,0.9,1,1.7,1.5,2.5H170v2.5h-42c7,9.2,17.6,14,31.4,14c23.1,0,37.3-13.6,40.7-38.6h-21.2v-1.9H200.2z  M177,95h4.3v4.3H177V95z M159.3,154.3c-7.9,0-9.4-7.1-9.4-20.1c0-12.9,1.5-19.9,9.4-19.9c7.8,0,9.3,7,9.3,19.9 C168.6,147.2,167.1,154.3,159.3,154.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_142_",
    className: "st62",
    d: "M251.4,148.6c-4.1-0.9-8.3-1.7-12.5-2h-30.3v2H251.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_312_",
    className: "st62",
    d: "M283.2,142.5V124h-3.7v-7h3.7V108H280v-7h3.2v-5.4h-18.1v-1.2h18.1V93h-21.4v-2.5h21.4 v-3.1h-34.4l-3.5,5h6.7v1.2h-7.5l-1,1.4h6.5v2.5h-8.3l-33,47v0.3h37.6v1.3c3.1,0.5,6.1,1.2,9.2,1.9c0.9,0.2,1.9,0.4,2.8,0.6 h7.1l-6-6c-0.7-0.7,0.4-1.7,1.1-1.1l7,7h4.9v2.6h1.6v1.2h-1.6v1.1l0.8,0.8c0.2,0.2,0.2,0.4,0.2,0.6c0.2,0.1,0.5,0.2,0.7,0.3 c0.9,0.4,0.5,1.8-0.4,1.4c-0.4-0.2-0.9-0.4-1.3-0.6v1.6h-63.7v10.5h41v2.9h0.7v11.6h32.8v-11.6h9.6v-28.6H283.2z M220.5,141.6 h-4.3v-4.3h4.3V141.6z M231.1,138.5h-7v-7h7V138.5z M252.8,142.5h-10.1l10.1-15.4V142.5z M253,97.5v-7h7v7H253z M263.9,104.5 h-4.3v-4.3h4.3V104.5z M276.1,116.4H273v3.1h-8v-11h8v3.5h3.1V116.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_934_",
    x: 12.8,
    y: 139,
    className: "st62",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_933_",
    x: 103.2,
    y: 105,
    className: "st62",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_932_",
    x: 112,
    y: 109,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_931_",
    x: 206.5,
    y: 122,
    className: "st62",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_930_",
    x: 287.3,
    y: 97.5,
    className: "st62",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_929_",
    x: 296.2,
    y: 101.5,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_925_",
    x: 215.1,
    y: 115.5,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_919_",
    x: 194.5,
    y: 95,
    className: "st62",
    width: 4.3,
    height: 4.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_881_",
    className: "st54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_286_",
    className: "st62",
    d: "M100.8,131.6h-6v-7h6v-9.1h-5.4v-7h5.4v-5.4H80.5v-1.2h20.3v-1.4H77.2V98h23.6V88H65.9 l-8.3,11.9h9.7v1.2H56.7l-1,1.4h9.6v2.5H54l-27.7,39.5v7.8h35.4v1.9H26.3v4.6h63v1.2h-63v9.2H67v1.9h1V185h32.8v-13.9h9.6 v-6.2h-6.8V160h6.8v-17.5h-9.6V131.6z M35.9,149.2h-4.3v-4.3h4.3V149.2z M46.5,146h-7v-7h7V146z M68.4,98h7v7h-7V98z  M70.4,142.5H60.3l10.1-15.4V142.5z M79.3,112h-0.6v2h-12v-8h12v1.7h0.6V112z M91.5,123.9h-2v2.1h-9.2v-7.2h9.2v0.8h2V123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_174_",
    className: "st62",
    d: "M199.7,144.8c0.4-3.3,0.6-6.9,0.6-10.6c0-10-1.4-18.5-4-25.7h-30.8v-4.9h28.7 c-6.7-13.3-18.7-20.3-35.4-20.3c-9.8,0-18,2.5-24.5,7.2h39.8V93h-42.8c-9.1,8.5-14,22.4-14,41.2c0,10,1.4,18.6,4,25.8h28.7 v4.9H149v1.4h-24.7c0.5,0.9,1,1.7,1.5,2.5h43.8v2.5h-42c7,9.2,17.6,14,31.4,14c23.1,0,37.3-13.6,40.7-38.6h-21.2v-1.9H199.7z  M176.6,95h4.3v4.3h-4.3V95z M158.9,154.3c-7.9,0-9.4-7.1-9.4-20.1c0-12.9,1.5-19.9,9.4-19.9c7.8,0,9.3,7,9.3,19.9 C168.1,147.2,166.7,154.3,158.9,154.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_143_",
    className: "st62",
    d: "M251.4,148.6c-4.1-0.9-8.3-1.7-12.5-2h-30.7v2H251.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_223_",
    className: "st62",
    d: "M282.8,142.5V124H279v-7h3.7V108h-3.2v-7h3.2v-5.4h-18.1v-1.2h18.1V93h-21.4v-2.5h21.4 v-3.1h-34.4l-3.5,5h6.7v1.2h-7.5l-1,1.4h6.5v2.5h-8.3l-33,47v0.3h37.6v1.3c3.2,0.6,6.4,1.3,9.6,2c0.9,0.2,1.9,0.4,2.8,0.6h7.1 l-6-6c-0.7-0.7,0.4-1.7,1.1-1.1l7,7h4.9v2.6h1.2v1.2h-1.2v1.1l0.8,0.8c0.2,0.2,0.2,0.4,0.2,0.6c0.2,0.1,0.5,0.2,0.7,0.3 c0.9,0.4,0.5,1.8-0.4,1.4c-0.4-0.2-0.9-0.4-1.3-0.6v1.6h-64.1v10.5h41.5v2.9h0.2v11.6h32.8v-11.6h9.6v-28.6H282.8z  M220.1,141.6h-4.3v-4.3h4.3V141.6z M230.7,138.5h-7v-7h7V138.5z M252.3,142.5h-10.1l10.1-15.4V142.5z M252.5,97.5v-7h7v7 H252.5z M263.5,104.5h-4.3v-4.3h4.3V104.5z M275.7,116.4H273v3.1h-8v-11h8v3.5h2.7V116.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_889_",
    x: 12.4,
    y: 139,
    className: "st62",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_888_",
    x: 102.7,
    y: 105,
    className: "st62",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_887_",
    x: 111.6,
    y: 109,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_886_",
    x: 206,
    y: 122,
    className: "st62",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_885_",
    x: 286.9,
    y: 97.5,
    className: "st62",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_884_",
    x: 295.8,
    y: 101.5,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_883_",
    x: 214.7,
    y: 115.5,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_882_",
    x: 194.1,
    y: 95,
    className: "st62",
    width: 4.3,
    height: 4.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_844_",
    className: "st55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_294_",
    className: "st62",
    d: "M100.4,131.6h-6v-7h6v-9.1H95v-7h5.4v-5.4H80.1v-1.2h20.3v-1.4H76.7V98h23.6V88H65.5 l-8.3,11.9h9.7v1.2H56.3l-1,1.4h9.6v2.5H53.6l-27.7,39.5v7.8h35.4v1.9H25.9v4.6h63v1.2h-63v9.2H67v1.9h0.6V185h32.8v-13.9h9.6 v-6.2h-6.8V160h6.8v-17.5h-9.6V131.6z M35.5,149.2h-4.3v-4.3h4.3V149.2z M46.1,146h-7v-7h7V146z M67.9,98h7v7h-7V98z  M69.9,142.5H59.8l10.1-15.4V142.5z M78.9,112h-0.2v2h-12v-8h12v1.7h0.2V112z M91.1,123.9h-1.6v2.1h-9.2v-7.2h9.2v0.8h1.6 V123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_178_",
    className: "st62",
    d: "M199.3,144.8c0.4-3.3,0.6-6.9,0.6-10.6c0-10-1.4-18.5-4-25.7h-30.8v-4.9h28.7 c-6.7-13.3-18.7-20.3-35.4-20.3c-9.8,0-18,2.5-24.5,7.2h39.8V93h-42.8c-9.1,8.5-14,22.4-14,41.2c0,10,1.4,18.6,4,25.8h28.7 v4.9H149v1.4h-25.2c0.5,0.9,1,1.7,1.5,2.5h43.8v2.5h-42c7,9.2,17.6,14,31.4,14c23.1,0,37.3-13.6,40.7-38.6h-21.2v-1.9H199.3z  M176.2,95h4.3v4.3h-4.3V95z M158.4,154.3c-7.9,0-9.4-7.1-9.4-20.1c0-12.9,1.5-19.9,9.4-19.9c7.8,0,9.3,7,9.3,19.9 C167.7,147.2,166.2,154.3,158.4,154.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_58_",
    className: "st62",
    d: "M251.4,148.6c-4.1-0.9-8.3-1.7-12.5-2h-31.2v2H251.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_147_",
    className: "st62",
    d: "M282.3,142.5V124h-3.7v-7h3.7V108h-3.2v-7h3.2v-5.4h-18.1v-1.2h18.1V93h-21.4v-2.5h21.4 v-3.1h-34.4l-3.5,5h6.7v1.2h-7.5l-1,1.4h6.5v2.5h-8.3l-33,47v0.3h37.6v1.2c3.4,0.6,6.7,1.3,10.1,2c0.9,0.2,1.9,0.4,2.8,0.6 h7.1l-6-6c-0.7-0.7,0.4-1.7,1.1-1.1l7,7h4.9v2.6h0.7v1.2h-0.7v1.1l0.8,0.8c0.2,0.2,0.2,0.4,0.2,0.6c0.2,0.1,0.5,0.2,0.7,0.3 c0.9,0.4,0.5,1.8-0.4,1.4c-0.4-0.2-0.9-0.4-1.3-0.6v1.6h-64.5v10.5h41.9v8h-0.2v6.5h32.8v-11.6h9.6v-28.6H282.3z M219.6,141.6 h-4.3v-4.3h4.3V141.6z M230.2,138.5h-7v-7h7V138.5z M251.9,142.5h-10.1l10.1-15.4V142.5z M252.1,97.5v-7h7v7H252.1z  M263.1,104.5h-4.3v-4.3h4.3V104.5z M275.2,116.4H273v3.1h-8v-11h8v3.5h2.3V116.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_852_",
    x: 11.9,
    y: 139,
    className: "st62",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_851_",
    x: 102.3,
    y: 105,
    className: "st62",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_850_",
    x: 111.1,
    y: 109,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_849_",
    x: 205.6,
    y: 122,
    className: "st62",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_848_",
    x: 286.4,
    y: 97.5,
    className: "st62",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_847_",
    x: 295.3,
    y: 101.5,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_846_",
    x: 214.2,
    y: 115.5,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_845_",
    x: 193.7,
    y: 95,
    className: "st62",
    width: 4.3,
    height: 4.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_799_",
    className: "st56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_302_",
    className: "st62",
    d: "M99.9,131.6h-6v-7h6v-9.1h-5.4v-7h5.4v-5.4H79.6v-1.2h20.3v-1.4H76.3V98h23.6V88H65 l-8.3,11.9h9.7v1.2H55.8l-1,1.4h9.6v2.5H53.1l-27.7,39.5v7.8h35.4v1.9H25.4v4.6h63v1.2h-63v9.2H67v1.9h0.1V185h32.8v-13.9h9.6 v-6.2h-6.8V160h6.8v-17.5h-9.6V131.6z M35,149.2h-4.3v-4.3H35V149.2z M45.6,146h-7v-7h7V146z M67.5,98h7v7h-7V98z M69.5,142.5 H59.4l10.1-15.4V142.5z M78.7,114h-12v-8h12V114z M90.6,123.9h-1.2v2.1h-9.2v-7.2h9.2v0.8h1.2V123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_190_",
    className: "st62",
    d: "M198.9,144.8c0.4-3.3,0.6-6.9,0.6-10.6c0-10-1.4-18.5-4-25.7h-30.8v-4.9h28.7 c-6.7-13.3-18.7-20.3-35.4-20.3c-9.8,0-18,2.5-24.5,7.2h39.8V93h-42.8c-9.1,8.5-14,22.4-14,41.2c0,10,1.4,18.6,4,25.8h28.7 v4.9H149v1.4h-25.6c0.5,0.9,1,1.7,1.5,2.5h43.8v2.5h-42c7,9.2,17.6,14,31.4,14c23.1,0,37.3-13.6,40.7-38.6h-21.2v-1.9H198.9z  M175.7,95h4.3v4.3h-4.3V95z M158,154.3c-7.9,0-9.4-7.1-9.4-20.1c0-12.9,1.5-19.9,9.4-19.9c7.8,0,9.3,7,9.3,19.9 C167.3,147.2,165.8,154.3,158,154.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_72_",
    className: "st62",
    d: "M281.9,142.5V124h-3.7v-7h3.7V108h-3.2v-7h3.2v-5.4h-18.1v-1.2h18.1V93h-21.4v-2.5h21.4 v-3.1h-34.4l-3.5,5h6.7v1.2h-7.5l-1,1.4h6.5v2.5h-8.3l-33,47v0.3h37.6v1.1c3.5,0.6,7,1.3,10.5,2.1c0.9,0.2,1.9,0.4,2.8,0.6 h7.1l-6-6c-0.7-0.7,0.4-1.7,1.1-1.1l7,7h4.9v2.6h0.3v1.2h-0.3v1.1l0.8,0.8c0.2,0.2,0.2,0.4,0.2,0.6c0.2,0.1,0.5,0.2,0.7,0.3 c0.9,0.4,0.5,1.8-0.4,1.4c-0.4-0.2-0.9-0.4-1.3-0.6v1.6h-65v10.5h42.4v8H249v6.5h32.8v-11.6h9.6v-28.6H281.9z M219.2,141.6 h-4.3v-4.3h4.3V141.6z M229.8,138.5h-7v-7h7V138.5z M251.4,142.5h-10.1l10.1-15.4V142.5z M251.6,97.5v-7h7v7H251.6z  M262.6,104.5h-4.3v-4.3h4.3V104.5z M274.8,116.4H273v3.1h-8v-11h8v3.5h1.8V116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_57_",
    className: "st62",
    d: "M251.4,148.6c-4.1-0.9-8.3-1.7-12.5-2h-31.6v2H251.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_815_",
    x: 11.5,
    y: 139,
    className: "st62",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_814_",
    x: 101.8,
    y: 105,
    className: "st62",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_813_",
    x: 110.7,
    y: 109,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_809_",
    x: 205.1,
    y: 122,
    className: "st62",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_803_",
    x: 286,
    y: 97.5,
    className: "st62",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_802_",
    x: 294.9,
    y: 101.5,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_801_",
    x: 213.8,
    y: 115.5,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_800_",
    x: 193.2,
    y: 95,
    className: "st62",
    width: 4.3,
    height: 4.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_770_",
    className: "st57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_166_",
    className: "st62",
    d: "M99.5,131.6h-6v-7h6v-9.1h-5.4v-7h5.4v-5.4H79.2v-1.2h20.3v-1.4H75.9V98h23.6V88H64.6 l-8.3,11.9H66v1.2H55.4l-1,1.4H64v2.5H52.7L25,144.5v7.8h35.4v1.9H25v4.6h63v1.2H25v9.2h42v8.5h-0.3v7.2h32.8v-13.9h9.6v-6.2 h-6.8V160h6.8v-17.5h-9.6V131.6z M34.6,149.2h-4.3v-4.3h4.3V149.2z M45.2,146h-7v-7h7V146z M67,98h7v7h-7V98z M69.1,142.5 H58.9l10.1-15.4V142.5z M78.7,114h-12v-8h12V114z M90.2,123.9h-0.7v2.1h-9.2v-7.2h9.2v0.8h0.7V123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_194_",
    className: "st62",
    d: "M198.4,144.8c0.4-3.3,0.6-6.9,0.6-10.6c0-10-1.4-18.5-4-25.7h-30.8v-4.9h28.7 c-6.7-13.3-18.7-20.3-35.4-20.3c-9.8,0-18,2.5-24.5,7.2h39.8V93H130c-9.1,8.5-14,22.4-14,41.2c0,10,1.4,18.6,4,25.8h28.7v2.8 h0.2v3.5h-26.1c0.5,0.9,1,1.7,1.5,2.5h43.8v2.5h-42c7,9.2,17.6,14,31.4,14c23.1,0,37.3-13.6,40.7-38.6H177v-1.9H198.4z  M175.3,95h4.3v4.3h-4.3V95z M157.5,154.3c-7.9,0-9.4-7.1-9.4-20.1c0-12.9,1.5-19.9,9.4-19.9c7.8,0,9.3,7,9.3,19.9 C166.8,147.2,165.3,154.3,157.5,154.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_59_",
    className: "st62",
    d: "M251.4,148.6c-4.1-0.9-8.3-1.7-12.5-2h-32.1v2H251.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_161_",
    className: "st62",
    d: "M281.4,142.5V124h-3.7v-7h3.7V108h-3.2v-7h3.2v-5.4h-18.1v-1.2h18.1V93H260v-2.5h21.4 v-3.1H247l-3.5,5h6.7v1.2h-7.5l-1,1.4h6.5v2.5h-8.3l-33,47v0.3h37.6v1c3.7,0.6,7.3,1.4,10.9,2.2c0.9,0.2,1.9,0.4,2.8,0.6h7.1 l-6-6c-0.7-0.7,0.4-1.7,1.1-1.1l7,7h4.9v4.9l0.8,0.8c0.2,0.2,0.2,0.4,0.2,0.6c0.2,0.1,0.5,0.2,0.7,0.3 c0.9,0.4,0.5,1.8-0.4,1.4c-0.4-0.2-0.9-0.4-1.3-0.6v1.6h-65.4v10.5h42.8v8h-1.1v6.5h32.8v-11.6h9.6v-28.6H281.4z M218.8,141.6 h-4.3v-4.3h4.3V141.6z M229.3,138.5h-7v-7h7V138.5z M251,142.5h-10.1l10.1-15.4V142.5z M251.2,97.5v-7h7v7H251.2z  M262.2,104.5h-4.3v-4.3h4.3V104.5z M274.3,116.4H273v3.1h-8v-11h8v3.5h1.4V116.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_778_",
    x: 11.1,
    y: 139,
    className: "st62",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_777_",
    x: 101.4,
    y: 105,
    className: "st62",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_776_",
    x: 110.3,
    y: 109,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_775_",
    x: 204.7,
    y: 122,
    className: "st62",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_774_",
    x: 285.6,
    y: 97.5,
    className: "st62",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_773_",
    x: 294.4,
    y: 101.5,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_772_",
    x: 213.4,
    y: 115.5,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_771_",
    x: 192.8,
    y: 95,
    className: "st62",
    width: 4.3,
    height: 4.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_741_",
    className: "st58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_230_",
    className: "st62",
    d: "M99,131.6h-6v-7h6v-9.1h-5.4v-7H99v-5.4H78.7v-1.2H99v-1.4H75.4V98H99V88H64.1 l-8.3,11.9h9.7v1.2H54.9l-1,1.4h9.6v2.5H52.2l-27.7,39.5v7.8h35.4v1.9H24.5v4.6h63v1.2h-63v9.2H67v8.5h-0.8v7.2H99v-13.9h9.6 v-6.2h-6.8V160h6.8v-17.5H99V131.6z M34.2,149.2h-4.3v-4.3h4.3V149.2z M44.7,146h-7v-7h7V146z M66.6,98h7v7h-7V98z  M68.6,142.5H58.5l10.1-15.4V142.5z M78.7,114h-12v-8h12V114z M89.7,123.9h-0.3v2.1h-9.2v-7.2h9.2v0.8h0.3V123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_198_",
    className: "st62",
    d: "M198,144.8c0.4-3.3,0.6-6.9,0.6-10.6c0-10-1.4-18.5-4-25.7h-30.8v-4.9h28.7 c-6.7-13.3-18.7-20.3-35.4-20.3c-9.8,0-18,2.5-24.5,7.2h39.8V93h-42.8c-9.1,8.5-14,22.4-14,41.2c0,10,1.4,18.6,4,25.8h28.7 v2.8h0.6v3.5h-26.5c0.5,0.9,1,1.7,1.5,2.5h43.8v2.5h-42c7,9.2,17.6,14,31.4,14c23.1,0,37.3-13.6,40.7-38.6h-21.2v-1.9H198z  M174.8,95h4.3v4.3h-4.3V95z M157.1,154.3c-7.9,0-9.4-7.1-9.4-20.1c0-12.9,1.5-19.9,9.4-19.9c7.8,0,9.3,7,9.3,19.9 C166.4,147.2,164.9,154.3,157.1,154.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_60_",
    className: "st62",
    d: "M251.4,148.6c-4.1-0.9-8.3-1.7-12.5-2h-32.5v2H251.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_216_",
    className: "st62",
    d: "M281,142.5V124h-3.7v-7h3.7V108h-3.2v-7h3.2v-5.4h-18.1v-1.2H281V93h-21.4v-2.5H281 v-3.1h-34.4l-3.5,5h6.7v1.2h-7.5l-1,1.4h6.5v2.5h-8.3l-33,47v0.3H244v1c3.8,0.6,7.6,1.4,11.4,2.2c0.9,0.2,1.9,0.4,2.8,0.6h7.1 l-6-6c-0.7-0.7,0.4-1.7,1.1-1.1l7,7h4.9v4.9l0.8,0.8c0.2,0.2,0.2,0.4,0.2,0.6c0.2,0.1,0.5,0.2,0.7,0.3 c0.9,0.4,0.5,1.8-0.4,1.4c-0.4-0.2-0.9-0.4-1.3-0.6v1.6h-65.9v10.5h43.3v8h-1.6v6.5H281v-11.6h9.6v-28.6H281z M218.3,141.6 H214v-4.3h4.3V141.6z M228.9,138.5h-7v-7h7V138.5z M250.5,142.5h-10.1l10.1-15.4V142.5z M250.7,97.5v-7h7v7H250.7z  M261.7,104.5h-4.3v-4.3h4.3V104.5z M273.9,116.4H273v3.1h-8v-11h8v3.5h0.9V116.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_749_",
    x: 10.6,
    y: 139,
    className: "st62",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_748_",
    x: 101,
    y: 105,
    className: "st62",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_747_",
    x: 109.8,
    y: 109,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_746_",
    x: 204.2,
    y: 122,
    className: "st62",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_745_",
    x: 285.1,
    y: 97.5,
    className: "st62",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_744_",
    x: 294,
    y: 101.5,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_743_",
    x: 212.9,
    y: 115.5,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_742_",
    x: 192.3,
    y: 95,
    className: "st62",
    width: 4.3,
    height: 4.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_712_",
    className: "st59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_238_",
    className: "st62",
    d: "M98.6,131.6h-6v-7h6v-9.1h-5.4v-7h5.4v-5.4H78.3v-1.2h20.3v-1.4H75V98h23.6V88H63.7 l-8.3,11.9h9.7v1.2H54.5l-1,1.4h9.6v2.5H51.8l-27.7,39.5v7.8h35.4v1.9H24.1v4.6h63v1.2h-63v9.2H67v8.5h-1.2v7.2h32.8v-13.9 h9.6v-6.2h-6.8V160h6.8v-17.5h-9.6V131.6z M33.7,149.2h-4.3v-4.3h4.3V149.2z M44.3,146h-7v-7h7V146z M66.1,98h7v7h-7V98z  M68.2,142.5H58.1l10.1-15.4V142.5z M78.7,114h-12v-8h12V114z M89.5,126h-9.2v-7.2h9.2V126z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_202_",
    className: "st62",
    d: "M197.5,144.8c0.4-3.3,0.6-6.9,0.6-10.6c0-10-1.4-18.5-4-25.7h-30.8v-4.9H192 c-6.7-13.3-18.7-20.3-35.4-20.3c-9.8,0-18,2.5-24.5,7.2H172V93h-42.8c-9.1,8.5-14,22.4-14,41.2c0,10,1.4,18.6,4,25.8h28.7v2.8 h1.1v3.5H122c0.5,0.9,1,1.7,1.5,2.5h43.8v2.5h-42c7,9.2,17.6,14,31.4,14c23.1,0,37.3-13.6,40.7-38.6h-21.2v-1.9H197.5z  M174.4,95h4.3v4.3h-4.3V95z M156.6,154.3c-7.9,0-9.4-7.1-9.4-20.1c0-12.9,1.5-19.9,9.4-19.9c7.8,0,9.3,7,9.3,19.9 C165.9,147.2,164.4,154.3,156.6,154.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_61_",
    className: "st62",
    d: "M251.4,148.6c-4.1-0.9-8.3-1.7-12.5-2H206v2H251.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_158_",
    className: "st62",
    d: "M280.5,142.5V124h-3.7v-7h3.7V108h-3.2v-7h3.2v-5.4h-18.1v-1.2h18.1V93h-21.4v-2.5h21.4 v-3.1h-34.4l-3.5,5h6.7v1.2h-7.5l-1,1.4h6.5v2.5H239l-33,47v0.3h37.6v0.9c4,0.6,7.9,1.5,11.8,2.3c0.9,0.2,1.9,0.4,2.8,0.6h7.1 l-6-6c-0.7-0.7,0.4-1.7,1.1-1.1l7,7h4.9v4.9l0.8,0.8c0.2,0.2,0.2,0.4,0.2,0.6c0.2,0.1,0.5,0.2,0.7,0.3 c0.9,0.4,0.5,1.8-0.4,1.4c-0.4-0.2-0.9-0.4-1.3-0.6v1.6H206v10.5h43.7v8h-2v6.5h32.8v-11.6h9.6v-28.6H280.5z M217.9,141.6 h-4.3v-4.3h4.3V141.6z M228.5,138.5h-7v-7h7V138.5z M250.1,142.5H240l10.1-15.4V142.5z M250.3,97.5v-7h7v7H250.3z  M261.3,104.5H257v-4.3h4.3V104.5z M273.4,116.4H273v3.1h-8v-11h8v3.5h0.5V116.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_720_",
    x: 10.2,
    y: 139,
    className: "st62",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_719_",
    x: 100.5,
    y: 105,
    className: "st62",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_718_",
    x: 109.4,
    y: 109,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_717_",
    x: 203.8,
    y: 122,
    className: "st62",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_716_",
    x: 284.7,
    y: 97.5,
    className: "st62",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_715_",
    x: 293.5,
    y: 101.5,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_714_",
    x: 212.5,
    y: 115.5,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_713_",
    x: 191.9,
    y: 95,
    className: "st62",
    width: 4.3,
    height: 4.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_683_",
    className: "st60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_246_",
    className: "st62",
    d: "M98.2,131.6h-6v-7h6v-9.1h-5.4v-7h5.4v-5.4H77.9v-1.2h20.3v-1.4H74.5V98h23.6V88H63.3 l-8.3,11.9h9.7v1.2H54.1l-1,1.4h9.6v2.5H51.3l-27.7,39.5v7.8H59v1.9H23.6v4.6h63v1.2h-63v9.2H67v8.5h-1.6v7.2h32.8v-13.9h9.6 v-6.2h-6.8V160h6.8v-17.5h-9.6V131.6z M33.3,149.2h-4.3v-4.3h4.3V149.2z M43.9,146h-7v-7h7V146z M65.7,98h7v7h-7V98z  M67.7,142.5H57.6l10.1-15.4V142.5z M78.7,114h-12v-8h12V114z M89.5,126h-9.2v-7.2h9.2V126z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_206_",
    className: "st62",
    d: "M197.1,144.8c0.4-3.3,0.6-6.9,0.6-10.6c0-10-1.4-18.5-4-25.7h-30.8v-4.9h28.7 c-6.7-13.3-18.7-20.3-35.4-20.3c-9.8,0-18,2.5-24.5,7.2h39.8V93h-42.8c-9.1,8.5-14,22.4-14,41.2c0,10,1.4,18.6,4,25.8h28.7 v2.8h1.5v3.5h-27.4c0.5,0.9,1,1.7,1.5,2.5h43.8v2.5h-42c7,9.2,17.6,14,31.4,14c23.1,0,37.3-13.6,40.7-38.6h-21.2v-1.9H197.1z  M173.9,95h4.3v4.3h-4.3V95z M156.2,154.3c-7.9,0-9.4-7.1-9.4-20.1c0-12.9,1.5-19.9,9.4-19.9c7.8,0,9.3,7,9.3,19.9 C165.5,147.2,164,154.3,156.2,154.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_62_",
    className: "st62",
    d: "M251.4,148.6c-4.1-0.9-8.3-1.7-12.5-2h-33.4v2H251.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_82_",
    className: "st62",
    d: "M280.1,142.5V124h-3.7v-7h3.7V108h-3.2v-7h3.2v-5.4H262v-1.2h18.1V93h-21.4v-2.5h21.4 v-3.1h-34.4l-3.5,5h6.7v1.2h-7.5l-1,1.4h6.5v2.5h-8.3l-33,47v0.3h37.6v0.8c4.1,0.6,8.2,1.5,12.3,2.4c0.9,0.2,1.9,0.4,2.8,0.6 h7.1l-6-6c-0.7-0.7,0.4-1.7,1.1-1.1l7,7h4.9v4.9l0.8,0.8c0.2,0.2,0.2,0.4,0.2,0.6c0.2,0.1,0.5,0.2,0.7,0.3 c0.9,0.4,0.5,1.8-0.4,1.4c-0.4-0.2-0.9-0.4-1.3-0.6v1.6h-66.8v10.5h44.1v8h-2.5v6.5h32.8v-11.6h9.6v-28.6H280.1z M217.4,141.6 h-4.3v-4.3h4.3V141.6z M228,138.5h-7v-7h7V138.5z M249.7,142.5h-10.1l10.1-15.4V142.5z M249.8,97.5v-7h7v7H249.8z  M260.8,104.5h-4.3v-4.3h4.3V104.5z M273,116.4L273,116.4l0,3.1h-8v-11h8v3.5h0V116.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_691_",
    x: 9.7,
    y: 139,
    className: "st62",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_690_",
    x: 100.1,
    y: 105,
    className: "st62",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_689_",
    x: 108.9,
    y: 109,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_688_",
    x: 203.4,
    y: 122,
    className: "st62",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_687_",
    x: 284.2,
    y: 97.5,
    className: "st62",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_686_",
    x: 293.1,
    y: 101.5,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_685_",
    x: 212,
    y: 115.5,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_684_",
    x: 191.4,
    y: 95,
    className: "st62",
    width: 4.3,
    height: 4.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_617_",
    className: "st61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_254_",
    className: "st62",
    d: "M97.7,131.6h-6v-7h6v-9.1h-5.4v-7h5.4v-5.4H77.4v-1.2h20.3v-1.4H74.1V98h23.6V88H62.8 l-8.3,11.9h9.7v1.2H53.6l-1,1.4h9.6v2.5H50.9l-27.7,39.5v7.8h35.4v1.9H23.2v4.6h63v1.2h-63v9.2H67v8.5h-2.1v7.2h32.8v-13.9 h9.6v-6.2h-6.8V160h6.8v-17.5h-9.6V131.6z M32.8,149.2h-4.3v-4.3h4.3V149.2z M43.4,146h-7v-7h7V146z M65.2,98h7v7h-7V98z  M67.3,142.5H57.2l10.1-15.4V142.5z M78.7,114h-12v-8h12V114z M89.5,126h-9.2v-7.2h9.2V126z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_210_",
    className: "st62",
    d: "M196.6,144.8c0.4-3.3,0.6-6.9,0.6-10.6c0-10-1.4-18.5-4-25.7h-30.8v-4.9h28.7 c-6.7-13.3-18.7-20.3-35.4-20.3c-9.8,0-18,2.5-24.5,7.2h39.8V93h-42.8c-9.1,8.5-14,22.4-14,41.2c0,10,1.4,18.6,4,25.8H147v2.8 h1.9v3.5h-27.8c0.5,0.9,1,1.7,1.5,2.5h43.8v2.5h-42c7,9.2,17.6,14,31.4,14c23.1,0,37.3-13.6,40.7-38.6h-21.2v-1.9H196.6z  M173.5,95h4.3v4.3h-4.3V95z M155.7,154.3c-7.9,0-9.4-7.1-9.4-20.1c0-12.9,1.5-19.9,9.4-19.9c7.8,0,9.3,7,9.3,19.9 C165,147.2,163.6,154.3,155.7,154.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_63_",
    className: "st62",
    d: "M251.4,148.6c-4.1-0.9-8.3-1.7-12.5-2h-33.8v2H251.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_90_",
    className: "st62",
    d: "M279.6,142.5V124h-3.7v-7h3.7V108h-3.2v-7h3.2v-5.4h-18.1v-1.2h18.1V93h-21.4v-2.5h21.4 v-3.1h-34.4l-3.5,5h6.7v1.2h-7.5l-1,1.4h6.5v2.5h-8.3l-33,47v0.3h37.6v0.8c4.3,0.6,8.5,1.5,12.7,2.4c0.9,0.2,1.9,0.4,2.8,0.6 h7.1l-6-6c-0.7-0.7,0.4-1.7,1.1-1.1l7,7h4.9v4.9l0.8,0.8c0.2,0.2,0.2,0.4,0.2,0.6c0.2,0.1,0.5,0.2,0.7,0.3 c0.9,0.4,0.5,1.8-0.4,1.4c-0.4-0.2-0.9-0.4-1.3-0.6v1.6h-67.2v10.5h44.6v8h-2.9v6.5h32.8v-11.6h9.6v-28.6H279.6z M217,141.6 h-4.3v-4.3h4.3V141.6z M227.6,138.5h-7v-7h7V138.5z M249.2,142.5h-10.1l10.1-15.4V142.5z M249.4,97.5v-7h7v7H249.4z  M260.4,104.5h-4.3v-4.3h4.3V104.5z M273,119.5h-8v-11h8V119.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_662_",
    x: 9.3,
    y: 139,
    className: "st62",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_661_",
    x: 99.6,
    y: 105,
    className: "st62",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_657_",
    x: 108.5,
    y: 109,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_656_",
    x: 202.9,
    y: 122,
    className: "st62",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_655_",
    x: 283.8,
    y: 97.5,
    className: "st62",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_654_",
    x: 292.6,
    y: 101.5,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_653_",
    x: 211.6,
    y: 115.5,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_647_",
    x: 191,
    y: 95,
    className: "st62",
    width: 4.3,
    height: 4.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_454_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_262_",
    className: "st62",
    d: "M97.3,131.6h-6v-7h6v-9.1h-5.4v-7h5.4v-5.4H77v-1.2h20.3v-1.4H73.6V98h23.6V88H62.4 L54,99.9h9.7v1.2H53.2l-1,1.4h9.6v2.5H50.4l-27.7,39.5v7.8h35.4v1.9H22.7v4.6h63v1.2h-63v9.2H67v8.5h-2.5v7.2h32.8v-13.9h9.6 v-6.2H100V160h6.8v-17.5h-9.6V131.6z M32.4,149.2H28v-4.3h4.3V149.2z M43,146h-7v-7h7V146z M64.8,98h7v7h-7V98z M66.8,142.5 H56.7l10.1-15.4V142.5z M78.7,114h-12v-8h12V114z M89.5,126h-9.2v-7.2h9.2V126z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_214_",
    className: "st62",
    d: "M196.2,144.8c0.4-3.3,0.6-6.9,0.6-10.6c0-10-1.4-18.5-4-25.7H162v-4.9h28.7 C184,90.3,172,83.3,155.3,83.3c-9.8,0-18,2.5-24.5,7.2h39.8V93h-42.8c-9.1,8.5-14,22.4-14,41.2c0,10,1.4,18.6,4,25.8h28.7v2.8 h2.4v3.5h-28.3c0.5,0.9,1,1.7,1.5,2.5H166v2.5h-42c7,9.2,17.6,14,31.4,14c23.1,0,37.3-13.6,40.7-38.6h-21.2v-1.9H196.2z  M173,95h4.3v4.3H173V95z M155.3,154.3c-7.9,0-9.4-7.1-9.4-20.1c0-12.9,1.5-19.9,9.4-19.9c7.8,0,9.3,7,9.3,19.9 C164.6,147.2,163.1,154.3,155.3,154.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_64_",
    className: "st62",
    d: "M251.4,148.6c-4.1-0.9-8.3-1.7-12.5-2h-34.3v2H251.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_120_",
    className: "st62",
    d: "M279.2,142.5V124h-3.7v-7h3.7V108H276v-7h3.2v-5.4h-18.1v-1.2h18.1V93h-21.4v-2.5h21.4 v-3.1h-34.4l-3.5,5h6.7v1.2h-7.5l-1,1.4h6.5v2.5h-8.3l-33,47v0.3h37.6v0.7c4.4,0.6,8.8,1.5,13.2,2.5c0.9,0.2,1.9,0.4,2.8,0.6 h7.1l-6-6c-0.7-0.7,0.4-1.7,1.1-1.1l7,7h4.9v4.9l0.8,0.8c0.2,0.2,0.2,0.4,0.2,0.6c0.2,0.1,0.5,0.2,0.7,0.3 c0.9,0.4,0.5,1.8-0.4,1.4c-0.4-0.2-0.9-0.4-1.3-0.6v1.6h-67.7v10.5h45v8h-3.3v6.5h32.8v-11.6h9.6v-28.6H279.2z M216.5,141.6 h-4.3v-4.3h4.3V141.6z M227.1,138.5h-7v-7h7V138.5z M248.8,142.5h-10.1l10.1-15.4V142.5z M249,97.5v-7h7v7H249z M259.9,104.5 h-4.3v-4.3h4.3V104.5z M273,119.5h-8v-11h8V119.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_462_",
    x: 8.8,
    y: 139,
    className: "st62",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_461_",
    x: 99.2,
    y: 105,
    className: "st62",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_460_",
    x: 108,
    y: 109,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_459_",
    x: 202.5,
    y: 122,
    className: "st62",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_458_",
    x: 283.3,
    y: 97.5,
    className: "st62",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_457_",
    x: 292.2,
    y: 101.5,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_456_",
    x: 211.1,
    y: 115.5,
    className: "st62",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_455_",
    x: 190.5,
    y: 95,
    className: "st62",
    width: 4.3,
    height: 4.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_89_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_101_",
    className: "st50",
    d: "M99,160h6.8v-17.5h-9.6v-11h-6v-7h6v-9.1h-5.4v-7h5.4v-5.4H76v-1.2h20.3v-1.4H72.6V98 h23.6V86.9H62.2l-9.1,13h9.7v1.2H52.2l-1,1.4h9.6v2.5H49.4l-27.7,39.5v7.8h35.4v1.9H21.7v4.6h63v1.2h-63v11.1h41.7v14.7h32.8 v-14.7h9.6v-6.2H99V160z M63.8,98h7v7h-7V98z M31.4,149.2H27v-4.3h4.3V149.2z M42,146h-7v-7h7V146z M65.8,142.5H55.7l10.1-15.4 V142.5z M74.8,112h-4.3v-4.3h4.3V112z M86.9,123.9h-4.3v-4.3h4.3V123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_109_",
    className: "st50",
    d: "M173.8,144.8h21.4c0.4-3.3,0.6-6.9,0.6-10.6c0-10-1.4-18.5-4-25.7H161v-4.9h28.7 C183,90.3,171,83.3,154.3,83.3c-9.8,0-18,2.5-24.5,7.2h39.8V93h-42.8c-9.1,8.5-14,22.4-14,41.2c0,10,1.4,18.6,4,25.8h28.7v4.9 H119c0.7,1.4,1.4,2.6,2.2,3.9H165v2.5h-42c7,9.2,17.6,14,31.4,14c23.1,0,37.3-13.6,40.7-38.6h-21.2V144.8z M172,95h4.3v4.3H172 V95z M154.3,154.3c-7.9,0-9.4-7.1-9.4-20.1c0-12.9,1.5-19.9,9.4-19.9c7.8,0,9.3,7,9.3,19.9 C163.6,147.2,162.1,154.3,154.3,154.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_113_",
    className: "st50",
    d: "M278.2,124h-3.7v-7h3.7V108H275v-7h3.2v-5.4h-18.1v-1.2h18.1V93h-21.4v-2.5h21.4v-3.6 h-34.1l-3.8,5.5h6.7v1.2h-7.5l-1,1.4h6.5v2.5h-8.3l-33,47v0.3h37.6v1.9h-37.6v4.6h65.3v1.2h-65.3v18.7h41.7v14.7h32.8v-14.7 h9.6v-28.6h-9.6V124z M215.5,141.6h-4.3v-4.3h4.3V141.6z M226.1,138.5h-7v-7h7V138.5z M247.8,142.5h-10.1l10.1-15.4V142.5z  M248,90.5h7v7h-7V90.5z M258.9,104.5h-4.3v-4.3h4.3V104.5z M271.1,116.4h-4.3V112h4.3V116.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_125_",
    x: 7.8,
    y: 139,
    className: "st50",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_128_",
    x: 98.2,
    y: 105,
    className: "st50",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_132_",
    x: 107,
    y: 109,
    className: "st50",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_141_",
    x: 201.5,
    y: 122,
    className: "st50",
    width: 9.5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_144_",
    x: 282.3,
    y: 97.5,
    className: "st50",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_148_",
    x: 291.2,
    y: 101.5,
    className: "st50",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_149_",
    x: 210.1,
    y: 115.5,
    className: "st50",
    width: 4.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_157_",
    x: 189.5,
    y: 95,
    className: "st50",
    width: 4.3,
    height: 4.3
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_44_",
    y: 57.9,
    className: "st63",
    width: 52.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_46_",
    x: 11.3,
    y: 54.2,
    className: "st63",
    width: 17.1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_47_",
    x: 5.3,
    y: 11.7,
    className: "st63",
    width: 20.9,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_48_",
    x: 49.5,
    y: 7.9,
    className: "st63",
    width: 13.1,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_49_",
    x: 62,
    y: 20.1,
    className: "st63",
    width: 11.4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_50_",
    x: 61.1,
    y: 25.6,
    className: "st63",
    width: 9.3,
    height: 6.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_51_",
    x: 61.3,
    y: 35.8,
    className: "st63",
    width: 33.7,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_52_",
    x: 61.5,
    y: 42.6,
    className: "st63",
    width: 11.9,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_53_",
    x: 92.3,
    y: 10.2,
    className: "st63",
    width: 22.2,
    height: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_54_",
    x: 115.3,
    y: 38.1,
    className: "st63",
    width: 12.9,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_55_",
    x: 111.9,
    y: 42.6,
    className: "st63",
    width: 20.6,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_56_",
    x: 155.6,
    y: 10.2,
    className: "st63",
    width: 17.6,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_65_",
    x: 161.8,
    y: 16.2,
    className: "st63",
    width: 10.7,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_74_",
    x: 183.5,
    y: 42.6,
    className: "st63",
    width: 19.7,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_75_",
    x: 168.4,
    y: 51.4,
    className: "st63",
    width: 22,
    height: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_76_",
    x: 206.7,
    y: 38.1,
    className: "st63",
    width: 16.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_78_",
    x: 218.4,
    y: 18.8,
    className: "st63",
    width: 17.6,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_86_",
    x: 262,
    y: 55.2,
    className: "st63",
    width: 37,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_97_",
    x: 275.5,
    y: 49.3,
    className: "st63",
    width: 13.7,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_129_",
    x: 234.5,
    y: 7.9,
    className: "st63",
    width: 19.1,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_130_",
    x: 234.9,
    y: 11.6,
    className: "st63",
    width: 30.2,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_348_",
    x: 280.3,
    y: 18.8,
    className: "st63",
    width: 17.9,
    height: 2.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_349_",
    x: 234.5,
    y: 55.2,
    className: "st63",
    width: 11.4,
    height: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_350_",
    x: 10.1,
    y: 210.3,
    className: "st63",
    width: 86,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_351_",
    x: 103.8,
    y: 216.4,
    className: "st63",
    width: 62,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_352_",
    x: 104.2,
    y: 220.3,
    className: "st63",
    width: 62.4,
    height: 2.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_126_",
    x: 176.3,
    y: 210.3,
    className: "st63",
    width: 92.8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_127_",
    x: 175.7,
    y: 221.4,
    className: "st63",
    width: 95.2,
    height: 1.2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "DESIGNED_BY_FREEPIK"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.22e87e1821eb02a15117788f116053d8.svg";
export { ForwardRef as ReactComponent };